// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Rebuilt from latest shared implementation */

:root {
  --font-primary: 'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  --font-mono: 'IBM Plex Mono', 'Consolas', monospace;

  --text-xs: 0.75rem;
  --text-sm: 0.875rem;
  --text-base: 1rem;
  --text-lg: 1.125rem;
  --text-xl: 1.25rem;
  --text-2xl: 1.5rem;
  --text-3xl: 1.875rem;

  --leading-tight: 1.25;
  --leading-normal: 1.5;
  --leading-relaxed: 1.75;

  --ims-primary: #1E3A5F;
  --ims-primary-light: #2D5A8E;
  --ims-primary-dark: #0F1F33;
  --ims-secondary: #4A90D9;
  --ims-accent: #F59E0B;
  --ims-success: #10B981;
  --ims-warning: #F59E0B;
  --ims-danger: #EF4444;
  --ims-info: #3B82F6;

  --ims-text-primary: #1F2937;
  --ims-text-secondary: #6B7280;
  --ims-text-muted: #9CA3AF;
  --ims-text-light: #D1D5DB;

  --ims-bg-primary: #FFFFFF;
  --ims-bg-secondary: #F9FAFB;
  --ims-bg-tertiary: #F3F4F6;
  --ims-bg-card: #FFFFFF;

  --ims-border-light: #E5E7EB;
  --ims-border-medium: #D1D5DB;
  --ims-border-dark: #9CA3AF;

  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-card: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  --shadow-card-hover: 0 6px 14px rgba(0,0,0,0.08);
  --shadow-lg: 0 16px 28px rgba(15, 31, 51, 0.12);

  --space-1: 0.25rem;
  --space-2: 0.5rem;
  --space-3: 0.75rem;
  --space-4: 1rem;
  --space-5: 1.25rem;
  --space-6: 1.5rem;
  --space-8: 2rem;
  --space-10: 2.5rem;
  --space-12: 3rem;
  --space-16: 4rem;

  --radius-sm: 0.375rem;
  --radius-md: 0.5rem;
  --radius-lg: 0.75rem;
  --radius-xl: 1rem;
  --radius-2xl: 1.5rem;
  --radius-full: 9999px;
}

.statgenie-v2 {
  font-family: var(--font-primary);
  font-size: var(--text-base);
  line-height: var(--leading-normal);
  color: var(--ims-text-primary);
  background: var(--ims-bg-secondary);
  min-height: 100vh;

  /* Copy restriction: block text selection across the AI Insights report.
     Why? Team requirement — report content must not be copyable.
     CSS alone is not sufficient on all browsers; paired with onCopy/onCut
     handlers on the root wrapper for defence in depth. */
  -webkit-user-select: none;
  user-select: none;
}

/* Allow selection / typing inside form fields so the feedback form works. */
.statgenie-v2 input,
.statgenie-v2 textarea,
.statgenie-v2 [contenteditable="true"] {
  -webkit-user-select: text;
  user-select: text;
}

.statgenie-v2 * { box-sizing: border-box; }

/* Top Navigation Bar */
.sg-top-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1.5rem;
  background: var(--ims-bg-primary);
  border-bottom: 1px solid var(--ims-border-light);
}

.sg-top-nav__logo {
  flex: 0 0 auto;
}

.sg-logo {
  height: 50px;
  width: auto;
}

.sg-top-nav__profile {
  flex: 0 0 auto;
  position: relative;
}

.sg-profile-btn {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 0.75rem;
  background: transparent;
  border: 1px solid var(--ims-border-medium);
  border-radius: var(--radius-md);
  color: var(--ims-text-secondary);
  font-size: var(--text-sm);
  cursor: pointer;
  transition: all 0.2s ease;
}

.sg-profile-btn:hover {
  background: var(--ims-bg-tertiary);
  color: var(--ims-text-primary);
  border-color: var(--ims-border-dark);
}

.sg-profile-name-text {
  text-transform: capitalize;
}

.sg-profile-dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  background: var(--ims-bg-primary);
  border: 1px solid var(--ims-border-light);
  border-radius: var(--radius-lg);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  z-index: 100;
}

.sg-profile-info {
  padding: 1rem;
}

.sg-profile-name {
  font-weight: 600;
  font-size: var(--text-base);
  color: var(--ims-text-primary);
  margin-bottom: 0.5rem;
}

.sg-profile-detail {
  font-size: var(--text-sm);
  color: var(--ims-text-secondary);
  margin-bottom: 0.25rem;
}

.sg-profile-divider {
  height: 1px;
  background: var(--ims-border-light);
  margin: 0;
}

.sg-profile-action {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem 1rem;
  background: transparent;
  border: none;
  color: var(--ims-text-primary);
  font-size: var(--text-sm);
  cursor: pointer;
  text-align: left;
  transition: background 0.2s ease;
}

.sg-profile-action:hover {
  background: var(--ims-bg-tertiary);
}

.sg-profile-logout {
  color: var(--ims-danger);
}

.sg-profile-logout:hover {
  background: #FEF2F2;
}

/* Report Header — title + BETA pill + tagline
   Replaces legacy .sg-subheader inline strip. Kept the background token so it
   still sits visually between the nav and the nav-pills/cards. */
.sg-report-header {
  padding: 1.25rem 1.5rem 1rem;
  background: var(--ims-bg-tertiary);
  border-bottom: 1px solid var(--ims-border-light);
  text-align: center;
}

.sg-report-header__title {
  margin: 0;
  font-size: var(--text-2xl);
  font-weight: 700;
  line-height: var(--leading-tight);
  color: var(--ims-primary);
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;
}

.sg-report-header__title-text {
  letter-spacing: -0.01em;
}

.sg-report-header__tagline {
  margin: 0.375rem 0 0;
  font-size: var(--text-lg);
  font-weight: 500;
  color: var(--ims-text-secondary);
  line-height: var(--leading-normal);
}

/* Removed desktop/mobile tagline split — copy is now identical (test name only). */

/* BETA pill — amber tint of --ims-accent to stay in-system.
   Why a tint instead of raw --ims-accent on white? Solid amber reads as
   warning; a 15% tint reads as "status notice" which is exactly the intent. */
.sg-beta-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: var(--radius-full);
  font-size: 0.6875rem; /* 11px */
  font-weight: 700;
  letter-spacing: 0.06em;
  background: rgba(245, 158, 11, 0.15);
  color: #92400E;
  border: 1px solid rgba(245, 158, 11, 0.40);
  text-transform: uppercase;
  line-height: 1;
  vertical-align: middle;
  cursor: help; /* signals the native title tooltip on hover */
}

/* Beta info banner — left accent stripe + amber tint.
   Why left stripe? Mirrors pattern used elsewhere in the app for informational
   callouts, keeping this visually native rather than a one-off component. */
.sg-beta-banner {
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  padding: 0.75rem 0.875rem;
  margin: 0 0 var(--space-4);
  border-radius: var(--radius-lg);
  background: rgba(245, 158, 11, 0.08);
  border: 1px solid rgba(245, 158, 11, 0.25);
  border-left: 3px solid var(--ims-accent);
  color: var(--ims-text-primary);
  font-size: var(--text-sm);
  line-height: var(--leading-normal);
}

.sg-beta-banner__icon {
  flex-shrink: 0;
  font-size: 1.125rem;
  line-height: 1.25;
}

.sg-beta-banner__text {
  flex: 1 1;
  margin: 0;
}

/* Body wrapper holds the beta notice + What's new bullets stacked vertically.
   Why a wrapper? The banner is a horizontal flex row (icon | body | close).
   The body itself needs to stack vertically to show the notice followed by
   the bullet list, so we wrap them in a column-flowing container. */
.sg-beta-banner__body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* What's new sub-section — highlights student-facing changes between releases.
   Visually subordinate to the beta notice (lighter heading, indented list)
   so the beta context still reads as the primary message. */
.sg-beta-banner__whats-new-title {
  display: block;
  font-weight: 600;
  font-size: var(--text-sm);
  margin-bottom: 0.25rem;
}

.sg-beta-banner__whats-new-list {
  margin: 0;
  padding-left: 1.25rem;
  list-style: disc;
}

.sg-beta-banner__whats-new-list li {
  margin-bottom: 0.25rem;
  line-height: var(--leading-normal);
}

.sg-beta-banner__whats-new-list li:last-child {
  margin-bottom: 0;
}

.sg-beta-banner__text--mobile { display: none; }

.sg-beta-banner__close {
  flex-shrink: 0;
  background: transparent;
  border: none;
  color: var(--ims-text-muted);
  font-size: 1.25rem;
  line-height: 1;
  padding: 0 0.25rem;
  cursor: pointer;
  transition: color 0.15s ease;
  align-self: flex-start;
}

.sg-beta-banner__close:hover,
.sg-beta-banner__close:focus {
  color: var(--ims-text-primary);
  outline: none;
}

/* Legacy .sg-subheader selectors removed — replaced by .sg-report-header.
   Verified no external references before deletion. */

/* Top-Level Tab Navigation */
.sg-main-tab-nav-wrapper {
  width: 100%;
  background: var(--ims-bg-primary);
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 2px solid var(--ims-border-light);
}

.sg-main-tab-nav {
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 0;
  padding: 0;
  background: var(--ims-bg-primary);
}

.sg-report-tab-anchor {
  position: relative;
  display: flex;
  align-items: stretch;
}

.sg-main-tab {
  padding: 1rem 2.1rem;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  color: var(--ims-text-secondary);
  font-size: 0.98rem;
  font-weight: 650;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  margin-bottom: -2px;
}

.sg-main-tab:hover {
  color: var(--ims-primary);
  background: var(--ims-bg-secondary);
}

.sg-main-tab--active {
  color: var(--ims-primary);
  font-weight: 750;
  border-bottom-color: var(--ims-primary);
}

/* Tab Content Container — matches .sg-container max-width for consistent feel across tabs */
.sg-tab-content {
  padding: var(--space-6);
  max-width: 1200px;
  margin: 0 auto;
}

/* Evidence Library Full-Page Mode */
.sg-library-fullpage {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  background: var(--ims-bg-primary);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-card);
  overflow: visible;
  display: flex;
  flex-direction: column;
}

.sg-library-fullpage .sg-modal__header {
  flex-shrink: 0;
  border-bottom: 1px solid var(--ims-border-light);
  padding: var(--space-4) var(--space-6);
  position: sticky;
  top: 0;
  background: var(--ims-bg-primary);
  z-index: 10;
}

.sg-library-fullpage .sg-modal__body {
  flex: 1 1;
  overflow: visible;
  display: flex;
  padding: 0;
  min-height: 0;
}

.sg-library-fullpage .sg-library-nav {
  width: 30%;
  overflow-y: auto;
  border-right: 1px solid var(--ims-border-light);
  background: var(--ims-bg-secondary);
  position: sticky;
  top: 73px; /* Below sticky header */
  align-self: flex-start;
  max-height: calc(100vh - 73px);
}

.sg-library-fullpage .sg-library-content {
  flex: 1 1;
  overflow: visible;
  padding: var(--space-6);
}

/* Navigation Pills - Desktop Only */
.sg-nav-pills {
  display: flex;
  justify-content: center;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  background: var(--ims-bg-primary);
  border-bottom: 1px solid var(--ims-border-light);
}

.sg-nav-pill {
  padding: 0.5rem 1.25rem;
  background: var(--ims-bg-tertiary);
  border: 1px solid var(--ims-border-light);
  border-radius: var(--radius-full);
  color: var(--ims-text-secondary);
  font-size: var(--text-sm);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.sg-nav-pill:hover {
  background: var(--ims-primary);
  color: white;
  border-color: var(--ims-primary);
}

/* Back to Top - Desktop */
.sg-top-btn {
  display: none;
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  padding: 0.5rem 1rem;
  background: var(--ims-primary);
  border: none;
  border-radius: var(--radius-full);
  color: white;
  font-size: var(--text-sm);
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;
  z-index: 100;
}

.sg-top-btn--visible {
  display: block;
}

.sg-top-btn:hover {
  background: var(--ims-primary-light);
  transform: translateY(-2px);
}

/* Mobile Bottom Tab Bar — 4-column grid, always visible.
   Grid guarantees all 4 tabs fit without horizontal scrolling.
   z-index 9999 ensures it sits above ALL content. */
.sg-mobile-tab-bar {
  display: none;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  max-width: 100vw;
  z-index: 9999;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-top: 1px solid var(--ims-border-light);
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.10);
  padding: 0.25rem 0.25rem;
  padding-bottom: max(0.25rem, env(safe-area-inset-bottom));
  overflow: hidden;
}

@media (max-width: 768px) {
  .sg-mobile-tab-bar {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    align-items: stretch;
  }
}

.sg-mobile-tab-bar__btn {
  min-width: 0;
  width: 100%;
  padding: 0.38rem 0.15rem;
  background: transparent;
  border: none;
  border-top: 2px solid transparent;
  color: var(--ims-text-muted);
  font-size: 0.68rem;
  font-weight: 600;
  font-family: inherit;
  line-height: 1.05;
  cursor: pointer;
  white-space: normal;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.sg-mobile-tab-bar__btn:hover {
  color: var(--ims-text-secondary);
}

.sg-mobile-tab-bar__btn--active {
  color: var(--ims-primary);
  border-top-color: var(--ims-primary);
  font-weight: 700;
}

/* Narrow mobile (<420px): further shrink tab bar text */
@media (max-width: 420px) {
  .sg-mobile-tab-bar__btn {
    font-size: 0.625rem;
    padding: 0.32rem 0.1rem;
  }
}

/* Legacy .sg-float-menu — replaced by .sg-mobile-tab-bar, keeping for desktop
   back-to-top only. Ensure it never shows on mobile now. */
.sg-float-menu {
  display: none;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .sg-top-nav {
    padding: 0.75rem 1rem;
  }

  .sg-logo {
    height: 40px;
  }

  .sg-profile-btn {
    padding: 0.4rem 0.6rem;
  }

  .sg-profile-name-text {
    display: none;
  }

    .sg-report-header {
    padding: 1rem 1rem 0.875rem;
  }

  .sg-report-header__title {
    font-size: var(--text-xl);
    gap: 0.375rem;
  }

  .sg-report-header__tagline {
    font-size: var(--text-base);
    margin-top: 0.25rem;
  }

  .sg-beta-badge {
    font-size: 0.625rem; /* 10px */
    padding: 2px 7px;
    letter-spacing: 0.05em;
  }

  .sg-beta-banner {
    font-size: 0.8125rem;
    padding: 0.625rem 0.75rem;
    gap: 0.5rem;
  }

  .sg-beta-banner__text--desktop { display: none; }
  .sg-beta-banner__text--mobile { display: inline; }

  .sg-nav-pills {
    display: none;
  }

  /* Hide desktop top button on mobile */
  .sg-top-btn {
    display: none !important;
  }

  .sg-container {
    padding: var(--space-4);
    padding-bottom: 5rem;
  }
}

.sg-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--space-6);
}

.sg-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: var(--space-4);
}

.sg-print-btn,
.sg-inline-toggle,
.sg-tab,
.sg-lens-toggle button,
.sg-rating-btn,
.sg-modal__close,
.sg-accordion-header,
.sg-table-card__header {
  border: none;
  cursor: pointer;
  font-family: inherit;
}

.sg-print-btn {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-4);
  background: var(--ims-primary);
  color: white;
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
  font-weight: 600;
}

.sg-card {
  background: var(--ims-bg-card);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-card);
  padding: var(--space-6);
  margin-bottom: var(--space-4);
}

.sg-card h3 { margin: 0; font-size: var(--text-lg); font-weight: 650; }

/* Next 2 Tests Plan - Stronger action block styling */
.sg-next-steps {
  border-left: 4px solid var(--ims-warning);
  background: linear-gradient(to right, rgba(245, 158, 11, 0.03), var(--ims-bg-card));
  box-shadow: var(--shadow-card-hover);
}

.sg-next-steps h3 {
  color: var(--ims-primary);
  font-size: var(--text-xl);
  font-weight: 700;
  margin-bottom: var(--space-3);
}

.sg-next-steps__priority {
  font-size: var(--text-base);
  font-weight: 600;
  color: var(--ims-text-primary);
  margin: var(--space-3) 0;
  padding: var(--space-3);
  background: rgba(245, 158, 11, 0.08);
  border-radius: var(--radius-md);
  border-left: 3px solid var(--ims-warning);
}

.sg-next-steps__area-priority {
  font-size: var(--text-base);
  font-weight: 650;
  color: var(--ims-text-primary);
  margin: var(--space-3) 0;
  padding: var(--space-3) var(--space-4);
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.06), rgba(59, 130, 246, 0.04));
  border-radius: var(--radius-md);
  border-left: 4px solid #10b981;
  box-shadow: 0 1px 3px rgba(16, 185, 129, 0.08);
}

.sg-next-steps__outcome {
  font-size: var(--text-sm);
  color: var(--ims-text-secondary);
  margin-top: var(--space-4);
  padding-top: var(--space-3);
  border-top: 1px solid var(--ims-border-light);
  font-style: italic;
}

.sg-overall-section { margin-bottom: var(--space-4); }

.sg-sections-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-4);
  margin-bottom: var(--space-4);
}

.sg-top-card {
  background: var(--ims-bg-card);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-card);
  padding: var(--space-5);
  border: 1px solid var(--ims-border-light);
}

.sg-top-card--overall {
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.sg-top-card__title {
  font-size: var(--text-sm);
  color: var(--ims-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-weight: 650;
  margin-bottom: var(--space-2);
}

/* Section cards: reserve two title lines so percentile/marks rows align
   across cards even when one title wraps (e.g. Quantitative Ability & Data Interpretation) */
.sg-sections-row .sg-top-card__title {
  line-height: 1.3;
  min-height: 2.6em;
}

.sg-top-card__percentile {
  font-size: clamp(1.5rem, 3.5vw, 2rem);
  line-height: 1;
  color: var(--ims-primary);
  font-weight: 700;
  margin-bottom: var(--space-1);
}

.sg-top-card__marks {
  font-size: clamp(1.25rem, 2.5vw, 1.5rem);
  font-weight: 700;
  margin-bottom: var(--space-4);
}

.sg-readiness-row--iimb {
  padding-top: var(--space-3);
  border-top: 1px solid var(--ims-border-light);
}

.sg-readiness-row__label--iimb {
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.sg-readiness-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-3);
}

.sg-readiness-row__label {
  font-size: var(--text-sm);
  color: var(--ims-text-secondary);
  flex-shrink: 0;
}

.sg-pill {
  display: inline-block;
  padding: var(--space-1) var(--space-3);
  border-radius: var(--radius-full);
  font-size: var(--text-xs);
  font-weight: 650;
  text-align: right;
}

.sg-pill--success { background: #D1FAE5; color: #065F46; }
.sg-pill--danger { background: #FEE2E2; color: #991B1B; }
.sg-pill--neutral { background: var(--ims-bg-tertiary); color: var(--ims-text-muted); }

.sg-summary-card {
  background: linear-gradient(135deg, #F0F9FF 0%, #E0F2FE 100%);
  border-left: 4px solid var(--ims-secondary);
}

.sg-goal-card { border-top: 4px solid var(--ims-primary); }

.sg-goal-card__title {
  margin-top: var(--space-4);
  font-size: var(--text-xl);
  font-weight: 700;
  color: var(--ims-primary);
}

.sg-goal-card__why,
.sg-goal-card__focus,
.sg-goal-card__impact,
.sg-block-copy {
  color: var(--ims-text-secondary);
  line-height: var(--leading-relaxed);
  margin: var(--space-3) 0 0;
}

/* S3 — deterministic overall-contribution closer */
.sg-goal-card__impact {
  padding-top: var(--space-3);
  margin-top: var(--space-4);
  border-top: 1px solid var(--ims-border-light, #e5e7eb);
  color: var(--ims-text-primary);
  font-weight: 500;
}

.sg-block-header {
  display: flex;
  justify-content: space-between;
  gap: var(--space-4);
  align-items: flex-start;
  margin-bottom: var(--space-4);
}

.sg-lens-toggle {
  display: inline-flex;
  background: rgba(255,255,255,0.66);
  border: 1px solid var(--ims-border-light);
  border-radius: var(--radius-md);
  padding: 2px;
  gap: 2px;
}

.sg-lens-toggle button {
  padding: var(--space-2) var(--space-3);
  border-radius: calc(var(--radius-md) - 2px);
  font-size: var(--text-sm);
  background: transparent;
  color: var(--ims-text-secondary);
}

.sg-lens-toggle button.active {
  background: var(--ims-bg-primary);
  color: var(--ims-primary);
  box-shadow: var(--shadow-sm);
  font-weight: 650;
}

/* Evidence Library toggles — pill style matching Skill Meter baseline.
   Scoped to .sg-modal / .sg-library-fullpage so the report page toggle
   (in .sg-card) stays unchanged. */
.sg-modal .sg-lens-toggle,
.sg-library-fullpage .sg-lens-toggle {
  display: inline-flex;
  border: 1px solid #d1d8e0;
  border-radius: 999px;
  overflow: hidden;
  background: #fff;
  padding: 0;
  gap: 0;
  width: auto;
  flex-shrink: 0;
}
.sg-modal .sg-lens-toggle button,
.sg-library-fullpage .sg-lens-toggle button {
  padding: 7px 12px;
  border: 0;
  background: #fff;
  color: #374151;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
  font-family: inherit;
  border-radius: 0;
  white-space: nowrap;
  flex-shrink: 0;
}
.sg-modal .sg-lens-toggle button.active,
.sg-library-fullpage .sg-lens-toggle button.active {
  background: #111827;
  color: #fff;
  box-shadow: none;
  font-weight: 800;
}

.sg-summary-zones { display: grid; gap: var(--space-4); }

.sg-summary-zone {
  background: rgba(255,255,255,0.65);
  border: 1px solid rgba(255,255,255,0.8);
  border-radius: var(--radius-lg);
  padding: var(--space-4);
}

.sg-zone-label {
  font-size: var(--text-xs);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--ims-text-muted);
  font-weight: 700;
  margin-bottom: var(--space-2);
}

.sg-summary-zone p,
.sg-priority-item { margin: 0; line-height: var(--leading-relaxed); }

.sg-summary-actions { margin-top: var(--space-4); }

.sg-inline-toggle {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  background: transparent;
  color: var(--ims-primary);
  font-weight: 650;
  padding: 0;
}

.sg-tier-performance {
  background: var(--ims-bg-secondary);
  border-radius: var(--radius-md);
  padding: var(--space-4);
}

.sg-tier-performance h4 {
  margin: 0 0 var(--space-3);
  font-size: var(--text-sm);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--ims-text-secondary);
}

.sg-tier-performance__row {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--ims-border-light);
}

.sg-tier-performance__row:last-child { border-bottom: none; }
.sg-tier-performance__section { min-width: 64px; font-weight: 650; }
.sg-tier-performance__detail { color: var(--ims-text-secondary); }

.sg-tabs {
  display: inline-flex;
  background: var(--ims-bg-tertiary);
  border-radius: var(--radius-lg);
  padding: 4px;
  gap: 4px;
}

.sg-tab {
  background: transparent;
  color: var(--ims-text-secondary);
  padding: var(--space-2) var(--space-4);
  border-radius: calc(var(--radius-lg) - 4px);
  font-size: var(--text-sm);
  font-weight: 600;
}

.sg-tab--active {
  background: var(--ims-bg-primary);
  color: var(--ims-primary);
  box-shadow: var(--shadow-sm);
}

.sg-findings { display: grid; gap: var(--space-4); }

.sg-finding {
  border: 1px solid var(--ims-border-light);
  border-radius: var(--radius-lg);
  padding: var(--space-4);
  background: #FCFCFD;
}

.sg-finding__text {
  color: var(--ims-text-primary);
  line-height: var(--leading-relaxed);
  margin-bottom: var(--space-2);
}

.sg-finding__text strong { font-weight: 650; }

/* Section Panel - Restructured Layout */
.sg-section-panel {
  display: grid;
  gap: var(--space-6);
  padding: var(--space-4);
}

/* Strategy Context */
.sg-strategy-context {
  background: linear-gradient(135deg, var(--ims-bg-secondary), #F0F4F8);
  border-left: 4px solid var(--ims-primary);
  border-radius: var(--radius-lg);
  padding: var(--space-5);
}

.sg-strategy-context__label {
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--ims-primary);
  margin-bottom: var(--space-2);
}

.sg-strategy-context__text {
  color: var(--ims-text-primary);
  line-height: var(--leading-relaxed);
  font-size: var(--text-base);
}

/* Findings Grid - Two Column Layout */
.sg-findings-grid {
  display: grid;
  gap: var(--space-4);
}

.sg-finding-row {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: var(--space-4);
  align-items: start;
  border: 1px solid var(--ims-border-light);
  border-radius: var(--radius-lg);
  padding: var(--space-4);
  background: var(--ims-bg-card);
}

.sg-finding-row__label {
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--ims-text-secondary);
  padding-top: var(--space-1);
}

.sg-finding-row__content {
  display: grid;
  gap: var(--space-2);
}

.sg-finding-row__text {
  color: var(--ims-text-primary);
  line-height: var(--leading-relaxed);
}

.sg-finding-row__text strong { font-weight: 650; }

/* Finding Row Actions - Dual Buttons */
.sg-finding-row__actions {
  display: flex;
  gap: var(--space-3);
  flex-wrap: wrap;
  margin-top: var(--space-2);
}

.sg-inline-toggle--secondary {
  background: transparent;
  color: var(--ims-text-secondary);
  border: 1px solid var(--ims-border-light);
}

.sg-inline-toggle--secondary:hover {
  background: var(--ims-bg-secondary);
  color: var(--ims-text-primary);
}

/* Next Step */
.sg-next-step {
  background: linear-gradient(135deg, #F0FDF4, #DCFCE7);
  border-left: 4px solid var(--ims-success);
  border-radius: var(--radius-lg);
  padding: var(--space-5);
}

.sg-next-step__label {
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--ims-success);
  margin-bottom: var(--space-2);
}

.sg-next-step__text {
  color: var(--ims-text-primary);
  line-height: var(--leading-relaxed);
  font-weight: 500;
}

/* Mobile Responsive */
@media (max-width: 640px) {
  .sg-finding-row {
    grid-template-columns: 1fr;
    gap: var(--space-2);
  }
  
  .sg-finding-row__label {
    padding-top: 0;
  }
}
.sg-evidence-ref { color: var(--ims-secondary); }

.sg-priorities { display: grid; gap: var(--space-3); }

.sg-priority-item {
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-md);
  background: var(--ims-bg-secondary);
}

.sg-rating-card {
  text-align: center;
  padding: var(--space-4) var(--space-5);
  max-width: 1200px;
  margin: 0 auto;
  background: transparent;
  box-shadow: none;
  border-radius: 0;
  border-top: 1px solid var(--ims-border-light);
  margin-top: var(--space-4);
}

.sg-rating-subtitle {
  color: var(--ims-text-secondary);
  font-size: var(--text-sm);
  margin-top: var(--space-2);
}

.sg-rating-stars {
  margin: var(--space-4) 0;
}

.sg-rating-stars__row {
  display: flex;
  justify-content: center;
  gap: var(--space-2);
  margin-bottom: var(--space-2);
}

.sg-rating-star {
  font-size: 2.5rem;
  line-height: 1;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease;
  color: var(--ims-accent);
}

.sg-rating-star:hover {
  transform: scale(1.1);
}

.sg-rating-text {
  color: var(--ims-text-secondary);
  font-size: var(--text-sm);
  margin: 0;
}

.sg-rating-details {
  border-top: 1px solid var(--ims-border-light);
  padding-top: var(--space-4);
  margin-top: var(--space-4);
}

.sg-rating-details--visible {
  border-left: 3px solid var(--ims-primary);
  padding-left: var(--space-4);
  background: #f8fafc;
  border-radius: 0 var(--radius-lg) var(--radius-lg) 0;
  animation: sg-fadeIn 0.3s ease-out;
}

@keyframes sg-fadeIn {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}

.sg-rating-question {
  color: var(--ims-text-primary);
  font-size: var(--text-sm);
  font-weight: 500;
  margin-bottom: var(--space-3);
}

.sg-rating-tags {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  justify-content: center;
  margin-bottom: var(--space-4);
}

.sg-rating-tag {
  padding: var(--space-2) var(--space-3);
  background: var(--ims-bg-tertiary);
  border: 1px solid var(--ims-border-light);
  border-radius: var(--radius-full);
  color: var(--ims-text-primary);
  font-size: var(--text-sm);
  cursor: pointer;
  transition: all 0.2s ease;
}

.sg-rating-tag:hover {
  background: var(--ims-border-light);
}

.sg-rating-tag--selected {
  background: var(--ims-primary);
  color: white;
  border-color: var(--ims-primary);
}

.sg-rating-comment {
  width: 100%;
  padding: var(--space-3);
  background: #fff;
  border: 1px solid var(--ims-border-light);
  border-radius: var(--radius-lg);
  color: var(--ims-text-primary);
  font-size: var(--text-sm);
  font-family: inherit;
  resize: none;
  margin-bottom: var(--space-4);
}

.sg-rating-comment::placeholder {
  color: var(--ims-text-secondary);
  opacity: 0.8;
}

.sg-rating-comment:focus {
  outline: none;
  border-color: var(--ims-primary);
}

.sg-rating-submit {
  padding: var(--space-3) var(--space-6);
  background: var(--ims-primary);
  border: none;
  border-radius: var(--radius-lg);
  color: white;
  font-size: var(--text-base);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.sg-rating-submit:hover {
  background: var(--ims-primary-light);
}

.sg-rating-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.sg-rating-success {
  color: var(--ims-success);
  font-weight: 600;
  padding: var(--space-4);
}

.sg-accordion-list { display: grid; gap: var(--space-3); }

.sg-accordion-item {
  border: 1px solid var(--ims-border-light);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.sg-accordion-header {
  width: 100%;
  background: var(--ims-bg-secondary);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--space-4);
  color: var(--ims-text-primary);
  font-weight: 650;
}

.sg-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 31, 51, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-6);
  z-index: 1000;
}

.sg-modal {
  width: min(980px, 100%);
  max-height: 88vh;
  overflow: hidden;
  background: white;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  display: flex;
  flex-direction: column;
}

.sg-modal__header {
  display: flex;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-5) var(--space-6);
  border-bottom: 1px solid var(--ims-border-light);
}

.sg-modal__title { font-size: var(--text-lg); font-weight: 700; }
.sg-modal__subtitle { color: var(--ims-text-secondary); margin-top: var(--space-1); }

.sg-modal__header-actions {
  display: flex;
  gap: var(--space-3);
  align-items: flex-start;
}

.sg-modal__close {
  background: transparent;
  color: var(--ims-text-secondary);
  padding: var(--space-2);
  border-radius: var(--radius-md);
}

.sg-modal__body {
  padding: var(--space-5) var(--space-6);
  overflow: auto;
  display: grid;
  gap: var(--space-4);
}

.sg-empty { color: var(--ims-text-muted); }

.sg-table-card {
  border: 1px solid var(--ims-border-light);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.sg-table-card__header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-4);
  background: var(--ims-bg-secondary);
  padding: var(--space-4);
  text-align: left;
}

.sg-table-card__title { font-weight: 650; }
.sg-table-card__subtitle {
  color: var(--ims-text-secondary);
  font-size: var(--text-sm);
  margin-top: var(--space-1);
}

.sg-table-wrap { overflow: auto; }

.sg-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--text-sm);
}

.sg-table th {
  text-align: center;
  padding: var(--space-3) var(--space-4);
  background: var(--ims-bg-secondary);
  border-bottom: 2px solid var(--ims-primary-light, #2D5A8E);
  color: var(--ims-primary);
  font-size: var(--text-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* First header column — section/test/area names should stay left-aligned. */
.sg-table th:first-child {
  text-align: left;
}

.sg-table td {
  padding: var(--space-3) var(--space-4);
  border-bottom: 1px solid var(--ims-border-light);
  vertical-align: top;
  text-align: center;
  /* Preserve \\n line breaks in multiline cells (e.g. "71.4%\\n40.0%").
     Desktop cells use CSS pre-line; mobile cards use explicit <span> stacking
     via renderCellValue() for tighter layout control. */
  white-space: pre-line;
}

.sg-cell--multiline {
  display: flex;
  flex-direction: column;
}
.sg-cell--multiline-line {
  display: block;
}

/* Label column (first): left-aligned, allow text wrapping with max-width
   to prevent long names from squeezing numeric columns. */
.sg-table td:first-child {
  text-align: left;
  max-width: 180px;
  word-break: break-word;
  overflow-wrap: break-word;
}

/* Row hover — subtle background shift for scannability */
.sg-table tbody tr:hover td {
  background: rgba(30, 58, 95, 0.04);
}

.sg-table tr:last-child td { border-bottom: none; }

/* Simple Pattern Table Styles */
.sg-table--simple-pattern {
  font-size: var(--text-base);
}

.sg-table--simple-pattern td {
  padding: var(--space-4);
  vertical-align: middle;
}

.sg-status-cleared {
  color: var(--ims-success);
  font-weight: 600;
}

.sg-status-missed {
  color: var(--ims-danger);
  font-weight: 600;
}

/* Evidence Table Styles */
.sg-evidence-table {
  width: 100%;
}

.sg-evidence-table__header {
  margin-bottom: var(--space-4);
}

.sg-evidence-table__title {
  font-size: var(--text-lg);
  font-weight: 650;
  color: var(--ims-text-primary);
}

.sg-evidence-table__subtitle {
  color: var(--ims-text-secondary);
  font-size: var(--text-sm);
  margin-top: var(--space-1);
}

.sg-evidence-table__desktop {
  overflow-x: auto;
}

.sg-evidence-table__mobile {
  display: none;
}

.sg-evidence-table__source {
  margin-top: var(--space-4);
}

/* Source disclosure toggle — always visible. On desktop it auto-expands;
   CSS below hides the button on wide screens and shows the text inline. */
.sg-evidence-table__source-toggle {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--ims-text-muted);
  font-size: var(--text-xs);
  font-family: inherit;
  transition: color 0.15s ease;
}
.sg-evidence-table__source-toggle:hover {
  color: var(--ims-text-secondary);
}
.sg-evidence-table__source-chevron {
  display: inline-block;
  font-size: 10px;
  transition: transform 0.15s ease;
  line-height: 1;
}
.sg-evidence-table__source-chevron--open {
  transform: rotate(180deg);
}
.sg-evidence-table__source-text {
  margin-top: 4px;
  font-size: var(--text-xs);
  font-style: italic;
  color: var(--ims-text-muted);
  line-height: 1.5;
}

/* Desktop: show source text inline (no toggle needed). */
@media (min-width: 769px) {
  .sg-evidence-table__source-toggle {
    display: none;
  }
  .sg-evidence-table__source-text {
    display: block !important;
    margin-top: 0;
  }
}

/* Evidence Card Styles (Mobile) */
.sg-evidence-card {
  border: 1px solid var(--ims-border-light);
  border-left: 3px solid #d1d5db;
  border-radius: var(--radius-lg);
  margin-bottom: var(--space-3);
  overflow: hidden;
  background: var(--ims-bg-card);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

/* Zebra: alternate cards get a faint tint for vertical scanability. */
.sg-evidence-table__mobile .sg-evidence-card:nth-child(even) {
  background: rgba(248, 250, 252, 0.7);
}

.sg-evidence-card--highlight {
  border-left: 4px solid var(--ims-primary);
  background: linear-gradient(90deg, rgba(30, 58, 95, 0.06), var(--ims-bg-card) 12px);
  box-shadow: 0 1px 4px rgba(30, 58, 95, 0.08);
}

.sg-evidence-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-4);
  background: var(--ims-bg-secondary);
  border-bottom: 1px solid var(--ims-border-light);
}

.sg-evidence-card__title {
  font-weight: 700;
  color: var(--ims-text-primary);
  font-size: 0.9375rem;
}

.sg-evidence-card__subtitle {
  font-size: var(--text-xs);
  color: var(--ims-text-secondary);
  margin-top: var(--space-1);
  font-weight: 500;
}

.sg-evidence-card__badge {
  font-size: var(--text-xs);
  padding: 2px 8px;
  border-radius: var(--radius-full);
  background: var(--ims-primary);
  color: white;
  font-weight: 500;
}

.sg-evidence-card__body {
  padding: var(--space-3) var(--space-4);
  background: #fff;
}

/* Two-column paired row layout — each pair holds 2 label-value cells
   side by side. On ≤420px (see narrow mobile block), collapses to single column. */
.sg-evidence-card__row-pair {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 12px;
  padding: var(--space-2) 0;
  border-bottom: 1px solid #f3f4f6;
}
.sg-evidence-card__row-pair:last-child {
  border-bottom: none;
}
/* Odd item: single cell spans both columns */
.sg-evidence-card__row-pair--single {
  grid-template-columns: 1fr;
}

/* Individual cell within a row-pair — label above value */
.sg-evidence-card__cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.sg-evidence-card__label {
  font-size: var(--text-xs);
  color: var(--ims-text-muted);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sg-evidence-card__value {
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--ims-text-primary);
  text-align: left;
  /* Preserve \\n line breaks rendered by renderMobileCellValue() stacked <span>s. */
  white-space: pre-line;
  line-height: 1.35;
}

/* Subtle zebra striping for evidence tables (row count > 2).
   Tint at 4% for visible but non-competitive horizontal scaffolding. */
.sg-table tbody tr:nth-child(even) td {
  background: rgba(30, 58, 95, 0.04);
}

/* Table row highlight — current-test / first-row emphasis. */
.sg-table__row--highlight td {
  background: rgba(30, 58, 95, 0.08);
}

/* --- Useful Insights (_ai_meta) 2-column grid --- */

.sg-useful-insights {
  margin-top: 16px;
  padding: 12px 14px;
  background: #f6f8fa;
  border: 1px solid #e1e4e8;
  border-radius: 8px;
  font-size: 13px;
  color: #24292e;
}

.sg-useful-insights__title {
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 13px;
  color: var(--ims-text-primary, #1f2937);
}

/* 2-column grid — items auto-flow into two equal columns.
   Why 2 columns? The _ai_meta panel can produce 10+ bullets;
   stacking them in a single column elongates the modal unnecessarily.
   Two columns halve the vertical height while keeping each item readable. */
.sg-useful-insights__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 20px;
}

.sg-useful-insights__item {
  font-size: 13px;
  line-height: 1.5;
  padding: 2px 0;
  /* Bullet via CSS pseudo-element (cleaner than <ul>/<li> for grid layout). */
  padding-left: 14px;
  position: relative;
}
.sg-useful-insights__item::before {
  content: '•';
  position: absolute;
  left: 0;
  color: var(--ims-text-muted, #9ca3af);
}

.sg-useful-insights__count {
  color: #586069;
}

.sg-useful-insights__detail {
  color: var(--ims-text-secondary, #4b5563);
}

/* Mobile: collapse to 1 column (narrow screens can't fit 2 columns). */
@media (max-width: 640px) {
  .sg-useful-insights__grid {
    grid-template-columns: 1fr;
    gap: 2px 0;
  }
}

/* --- Mobile readiness cell sub-lines (Option C layout) --- */

/* Scored / Cutoff lines in mobile evidence cards — slightly smaller and muted
   so the status line (e.g. "❌ MISSED") remains the visual anchor. */
.sg-cell--readiness-scored,
.sg-cell--readiness-cutoff {
  font-size: 0.92em;
  color: var(--ims-text-secondary, #4b5563);
}

/* --- Backported from audit-viewer WAVE 2 ------------------------------- */

/* Clickable sort header (cursor + hover affordance only on actually-clickable ths). */
.sg-table__th--sortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background 0.12s ease-in-out;
}
.sg-table__th--sortable:hover {
  background: var(--ims-bg-tertiary, #eef2f7);
}
.sg-table__th--active {
  color: var(--ims-text-primary, #1a1a1a);
  background: var(--ims-bg-tertiary, #eef2f7);
}
.sg-table__th-label { margin-right: 0.35em; }

/* Multi-line <th>: '\\n' in column label → stacked sub-labels. */
.sg-table__th--multiline .sg-table__th-label {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
  vertical-align: middle;
}
.sg-table__th-label-primary {
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.sg-table__th-label-sub {
  font-size: 0.85em;
  font-weight: 600;
  color: var(--ims-text-secondary, #4b5563);
  text-transform: none;
  letter-spacing: 0;
  margin-top: 2px;
  cursor: help;
}
.sg-table__th-label-sub + .sg-table__th-label-sub { margin-top: 1px; }
.sg-table__th-chevron {
  display: inline-block;
  min-width: 0.9em;
  font-size: 0.85em;
  opacity: 0.5;
  font-family: system-ui, -apple-system, sans-serif;
}
.sg-table__th--active .sg-table__th-chevron { opacity: 1; }

/* Group-total row ('Overall' heuristic) — prominent border-top + bolder weight
   to clearly separate aggregate data from detail rows. */
.sg-table__row--overall td {
  font-weight: 650;
  border-top: 1.5px solid var(--ims-primary);
  background: rgba(30, 58, 95, 0.08);
}
/* Mobile counterpart on evidence cards — Overall rows get a subtle primary-tinted background
   and heavier weight to distinguish them from data rows at a glance. */
.sg-evidence-card--overall .sg-evidence-card__title,
.sg-evidence-card--overall .sg-evidence-card__subtitle,
.sg-evidence-card--overall .sg-evidence-card__value,
.sg-evidence-card--overall .sg-evidence-card__label { font-weight: 650; }
.sg-evidence-card--overall {
  background: linear-gradient(90deg, rgba(30, 58, 95, 0.05), var(--ims-bg-card));
  border-left: 3px solid var(--ims-primary);
}

/* Multi-line subtitle variant: when backend emits a '\\n'-joined subtitle,
   stack as a centered, prominent mini-scoreboard. Single-line keeps quiet tone. */
.sg-evidence-table__subtitle--multiline {
  text-align: center;
  font-size: var(--text-base);
  font-weight: 600;
  color: var(--ims-text-primary);
  margin-top: var(--space-3);
  line-height: 1.5;
}
.sg-evidence-table__subtitle--multiline .sg-evidence-table__subtitle-line + .sg-evidence-table__subtitle-line {
  margin-top: var(--space-1);
}

/* Title row — centered title with an optional subtle ⓘ button.
   Click expands a readable purpose panel below. No hover tooltips. */
.sg-evidence-table__title-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
}

.sg-evidence-table__info-btn {
  width: 24px;
  height: 24px;
  border: 1px solid var(--ims-border-light);
  border-radius: var(--radius-full);
  background: var(--ims-bg-primary);
  color: var(--ims-text-muted);
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: color 0.15s, border-color 0.15s, background 0.15s;
}
.sg-evidence-table__info-btn:hover,
.sg-evidence-table__info-btn--active {
  color: var(--ims-primary);
  border-color: var(--ims-primary);
  background: rgba(30, 58, 95, 0.06);
}

/* Purpose panel — readable, full-width below the title row.
   Centered, constrained, pleasant background. Appears on ⓘ click. */
.sg-evidence-table__purpose-panel {
  margin: 0.75rem auto 0;
  max-width: 760px;
  padding: 0.75rem 1rem;
  border-radius: var(--radius-lg);
  background: var(--ims-bg-secondary);
  border: 1px solid var(--ims-border-light);
  color: var(--ims-text-secondary);
  font-size: var(--text-sm);
  line-height: 1.55;
  text-align: left;
}

/* Mobile: Show card layout, hide table */
@media (max-width: 768px) {
  .sg-evidence-table__desktop {
    display: none !important;
  }

  .sg-evidence-table__mobile {
    display: block !important;
  }

  /* Explicitly force card view inside the Evidence Library full-page and modal containers.
     Why: the library's own pane toggling (nav↔content) can create stacking contexts where
     the desktop table re-emerges. These rules override that so cards always win on mobile. */
  .sg-library-fullpage .sg-evidence-table__desktop,
  .sg-library-content .sg-evidence-table__desktop,
  .sg-modal__body .sg-evidence-table__desktop {
    display: none !important;
  }

  .sg-library-fullpage .sg-evidence-table__mobile,
  .sg-library-content .sg-evidence-table__mobile,
  .sg-modal__body .sg-evidence-table__mobile {
    display: block !important;
  }

  /* Tighten evidence card spacing on mobile — less padding, smaller gaps */
  .sg-evidence-card {
    margin-bottom: var(--space-2);
  }
  .sg-evidence-card__header {
    padding: var(--space-2) var(--space-3);
  }
  .sg-evidence-card__body {
    padding: var(--space-2) var(--space-3);
  }
  .sg-evidence-card__row-pair {
    padding: var(--space-1) 0;
    gap: 2px 10px;
  }
  .sg-evidence-card__title {
    font-size: var(--text-sm);
  }
  .sg-evidence-card__label {
    font-size: 0.625rem;
  }
  .sg-evidence-card__value {
    font-size: 0.8125rem;
  }
}

/* Narrow mobile (<420px): collapse two-column grid to single column.
   Each cell in the pair stacks vertically. */
@media (max-width: 420px) {
  .sg-evidence-card__row-pair {
    grid-template-columns: 1fr;
    gap: 4px 0;
  }
  .sg-evidence-card__label {
    font-size: 0.625rem;
  }
  .sg-evidence-card__value {
    font-size: 0.8125rem;
  }
}

/* --- Evidence Library Modal — split-pane (backported from audit-viewer) --- */

/* Library shell: wider + taller than the small per-claim modal, and uses
   flex-column so the body can host a flex-row split-pane. */
.sg-modal--library {
  max-width: 1100px;
  width: 95vw;
  height: 85vh;
  display: flex;
  flex-direction: column;
}



/* Library body is the split-pane container (desktop). Padding is zero so the
   nav's border-right reaches the body edges; padding lives on each pane. */
.sg-modal--library .sg-modal__body {
  display: flex;
  flex-direction: row;
  flex: 1 1;
  min-height: 0;
  padding: 0;
  overflow: hidden;
}
.sg-library-body {
  display: flex;
  flex-direction: row;
  flex: 1 1;
  min-height: 0;
}

/* Left nav — fixed width, its own scroll. Categories auto-expand when they
   contain the selected entry so the user never loses orientation. */
.sg-library-nav {
  width: 300px;
  flex-shrink: 0;
  border-right: 1px solid var(--ims-border-light);
  overflow-y: auto;
  padding: var(--space-3);
  background: var(--ims-bg-secondary);
}

/* Right content pane — fills remaining width, its own scroll. */
.sg-library-content {
  flex: 1 1;
  min-width: 0;
  overflow-y: auto;
  padding: var(--space-4) var(--space-5);
}

/* Empty-state placeholder (right pane before any selection). */
.sg-library-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  color: var(--ims-text-secondary);
  padding: var(--space-6);
}
.sg-library-placeholder__title {
  font-size: var(--text-base);
  font-weight: 500;
  color: var(--ims-text-primary);
  margin-bottom: var(--space-2);
}
.sg-library-placeholder__hint {
  font-size: var(--text-sm);
  color: var(--ims-text-secondary);
  max-width: 320px;
  line-height: 1.5;
}

/* Mobile drill-down back button — hidden on desktop. Shown on <768px OR
   when .sg-modal--library-mobile-content is on (selection picked). */
.sg-modal__back-btn {
  display: none;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3);
  background: var(--ims-primary);
  border: 1px solid var(--ims-primary);
  border-radius: var(--radius-md);
  cursor: pointer;
  color: #ffffff;
  font-size: var(--text-sm);
  font-weight: 600;
  margin-right: var(--space-3);
  min-height: 40px;
  font-family: inherit;
}
.sg-modal__back-btn:hover { opacity: 0.9; }
.sg-modal__back-btn:active { opacity: 0.8; }
.sg-modal__back-btn-label { line-height: 1; }

/* --- Category accordion (top-level in left nav) --- */
.sg-library-category {
  margin-bottom: var(--space-2);
  /* Override the legacy single-column style (border/radius/overflow-hidden
     were appropriate for the full-width accordion; in split-pane they clip
     the header's focus ring and fight the nav background). */
  border: none;
  border-radius: 0;
  overflow: visible;
}
.sg-library-category__header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--space-3);
  background: var(--ims-bg-primary);
  border: 1px solid var(--ims-border-light);
  border-radius: var(--radius-md);
  cursor: pointer;
  text-align: left;
  font-size: var(--text-base);
  color: var(--ims-text-primary);
  font-family: inherit;
  transition: background 0.15s ease;
}
.sg-library-category__header:hover { background: var(--ims-bg-tertiary); }
.sg-library-category__header[aria-expanded="true"] {
  background: var(--ims-bg-tertiary);
  border-color: var(--ims-primary);
}
.sg-library-category__name {
  font-weight: 600;
  color: var(--ims-text-primary);
}
.sg-library-category__body {
  padding: var(--space-2) 0 var(--space-2) var(--space-2);
}
.sg-library-category__tables {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding: 0;
}

/* Leaf table button — default / selected / disabled states. */
.sg-library-table-btn {
  width: 100%;
  padding: var(--space-2) var(--space-3);
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--radius-sm);
  cursor: pointer;
  text-align: left;
  font-size: var(--text-sm);
  color: var(--ims-text-primary);
  font-family: inherit;
  transition: all 0.15s ease;
  line-height: 1.4;
}
.sg-library-table-btn:hover:not(:disabled) {
  background: var(--ims-bg-primary);
  border-color: var(--ims-primary);
}
.sg-library-table-btn--disabled,
.sg-library-table-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  font-style: italic;
}
.sg-library-table-btn--disabled:hover,
.sg-library-table-btn:disabled:hover {
  background: transparent;
  border-color: transparent;
}
.sg-library-table-btn--selected {
  background: var(--ims-primary);
  color: #ffffff;
  border-color: var(--ims-primary);
  font-weight: 600;
}
.sg-library-table-btn--selected:hover:not(:disabled) {
  background: var(--ims-primary);
  color: #ffffff;
  border-color: var(--ims-primary);
}

/* Mobile drill-down (<768px) — single pane at a time with a Back button. */
@media (max-width: 768px) {
  .sg-modal--library {
    width: 100vw;
    height: 100vh;
    max-width: 100vw;
    max-height: 100vh;
    border-radius: 0;
  }
  .sg-library-body {
    flex-direction: column;
    position: relative;
  }
  .sg-library-nav {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid var(--ims-border-light);
    flex: 1 1;
    min-height: 0;
  }
  .sg-library-content { display: none; }

  /* When a table is picked, swap panes: content fills, nav hides, Back shows. */
  .sg-modal--library-mobile-content .sg-library-nav { display: none; }
  .sg-modal--library-mobile-content .sg-library-content {
    display: block;
    flex: 1 1;
    min-height: 0;
  }
  .sg-modal--library-mobile-content .sg-modal__back-btn { display: inline-flex; }
  .sg-modal--library-mobile-content .sg-modal__close { display: none; }

  .sg-modal--library .sg-modal__header {
    flex-wrap: wrap;
    gap: var(--space-2);
  }
  .sg-modal--library .sg-modal__header-actions { flex-wrap: wrap; }

  .sg-library-table-btn {
    padding: var(--space-3);
    font-size: var(--text-base);
  }

  /* Full-page mode mobile styles (mirrors modal mobile behavior) */
  .sg-library-fullpage {
    min-height: auto;
    max-width: 100vw;
    max-height: none;
    border-radius: 0;
  }

  .sg-library-fullpage .sg-modal__body {
    flex-direction: column;
  }

  .sg-library-fullpage .sg-library-nav {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid var(--ims-border-light);
    flex: 1 1;
    min-height: 0;
  }

  .sg-library-fullpage .sg-library-content {
    display: none;
  }

  /* When a table is picked in full-page mobile, swap panes */
  .sg-library-fullpage--content-view .sg-library-nav {
    display: none;
  }

  .sg-library-fullpage--content-view .sg-library-content {
    display: block;
    flex: 1 1;
    min-height: 0;
    overflow-y: auto;
  }

  /* Push content above the persistent bottom tab bar */
  .sg-library-fullpage .sg-modal__body {
    flex-direction: column;
    padding-bottom: calc(5.25rem + env(safe-area-inset-bottom));
  }

  /* Back button: only show in content-view (when a table is selected) */
  .sg-library-fullpage .sg-modal__back-btn {
    display: none;
  }
  .sg-library-fullpage--content-view .sg-modal__back-btn {
    display: inline-flex;
  }

  /* Two-row header: title row centered, controls row (back + toggle) below.
     Prevents cramming and horizontal overflow on narrow screens. */
  .sg-library-fullpage .sg-modal__header {
    display: grid;
    grid-template-areas:
      "title title"
      "back  actions";
    grid-template-columns: auto 1fr;
    align-items: center;
    gap: 0.35rem 0.5rem;
    padding: 0.75rem 1rem;
  }
  /* Title wrapper — the unclassed div between back button and actions */
  .sg-library-fullpage .sg-modal__header > :not(.sg-modal__back-btn):not(.sg-modal__header-actions) {
    grid-area: title;
    justify-self: center;
    text-align: center;
  }
  .sg-library-fullpage .sg-modal__title {
    text-align: center;
    font-size: 1rem;
    line-height: 1.2;
  }
  .sg-library-fullpage .sg-modal__back-btn {
    grid-area: back;
  }
  .sg-library-fullpage .sg-modal__header-actions {
    grid-area: actions;
    justify-self: end;
    flex-wrap: wrap;
  }

  /* Smaller, subtler back button */
  .sg-modal__back-btn {
    padding: 0.35rem 0.55rem;
    font-size: 0.78rem;
    border-radius: var(--radius-full);
    background: var(--ims-bg-primary);
    color: var(--ims-primary);
    border: 1px solid var(--ims-border-medium, #d1d5db);
    gap: 0.25rem;
    min-height: auto;
  }
}

/* Nav Pill Icon Style */
.sg-nav-pill--icon {
  min-width: 40px;
  text-align: center;
}

.sg-loading {
  display: flex;
  min-height: 60vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-4);
}

/* Compact variant — reduces vertical space for quick loads */
.sg-loading--compact {
  min-height: 40vh;
}

.sg-loading__spinner {
  width: 44px;
  height: 44px;
  border: 3px solid var(--ims-border-light);
  border-top-color: var(--ims-primary);
  border-radius: 50%;
  animation: sg-spin 1s linear infinite;
}

.sg-loading__text { color: var(--ims-text-secondary); font-size: var(--text-base); }

@keyframes sg-spin { to { transform: rotate(360deg); } }

@media (max-width: 860px) {
  .sg-container { padding: var(--space-4); }
  .sg-sections-row { grid-template-columns: 1fr; }
  .sg-block-header { flex-direction: column; align-items: flex-start; }
  .sg-tier-performance__row { flex-direction: column; }
  .sg-modal-backdrop { padding: var(--space-3); }
  .sg-modal { max-height: 92vh; }
}

@media print {
  .sg-toolbar,
  .sg-modal-backdrop,
  .sg-rating-card,
  .sg-lens-toggle,
  .sg-inline-toggle,
  .sg-beta-banner {
    display: none !important;
  }

  /* Keep the BETA pill visible in print so the document carries its status,
     but strip interactive affordances. */
  .sg-beta-badge {
    cursor: default;
  }

  .sg-card,
  .sg-top-card {
    box-shadow: none;
    border: 1px solid var(--ims-border-light);
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .sg-container {
    max-width: none;
    padding: 0;
  }
}

/* ============================================
   IMS FOOTER - Design Team Requirements
   ============================================ */

.sg-footer {
  background-color: var(--ims-bg-secondary);
  border-top: 1px solid var(--ims-border-light);
  margin-top: var(--space-12);
  padding: var(--space-8) 0;
}

.sg-footer__inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--space-6);
}

/* AI Disclaimer — shown only in Report tab */
.sg-ai-disclaimer {
  background-color: var(--ims-bg-tertiary);
  border-left: 4px solid var(--ims-accent);
  padding: var(--space-4);
  margin-top: var(--space-8);
  margin-bottom: var(--space-4);
  border-radius: 0 var(--radius) var(--radius) 0;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.sg-ai-disclaimer p {
  font-size: var(--text-sm);
  color: var(--ims-text-secondary);
  line-height: var(--leading-normal);
  margin: 0;
}

.sg-ai-disclaimer strong {
  color: var(--ims-text-primary);
  font-weight: 600;
}

/* Navigation Links */
.sg-footer__links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: var(--space-3);
  margin-bottom: var(--space-6);
  padding: var(--space-4) 0;
  border-top: 1px solid var(--ims-border-light);
}

.sg-footer__links a {
  font-size: var(--text-sm);
  color: var(--ims-text-secondary);
  text-decoration: none;
  transition: color 0.2s ease;
}

.sg-footer__links a:hover {
  color: var(--ims-primary);
  text-decoration: underline;
}

.sg-footer__divider {
  color: var(--ims-text-muted);
  font-size: var(--text-sm);
}

/* Social Icons */
.sg-footer__social {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-4);
  margin-bottom: var(--space-6);
  padding-top: var(--space-6);
  border-top: 1px solid var(--ims-border-light);
}

.sg-footer__social span {
  font-size: var(--text-sm);
  color: var(--ims-text-muted);
}

/* Mobile Responsiveness for Tab Navigation */
@media (max-width: 768px) {
  .sg-main-tab-nav {
    display: none;
  }

  .sg-tab-content {
    padding: 1rem;
    padding-bottom: calc(5.25rem + env(safe-area-inset-bottom)); /* clear the persistent bottom tab bar */
  }

  /* Hide desktop tab wrapper completely on mobile — no border, no padding */
  .sg-main-tab-nav-wrapper {
    display: none !important;
    height: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    border: 0 !important;
  }

  /* Mobile full-screen tool overlays */
  .sg-mobile-tool-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--ims-bg-primary);
    z-index: 1000;
    overflow-y: auto;
  }

  .sg-mobile-tool-overlay .sg-modal__header {
    position: sticky;
    top: 0;
    background: var(--ims-bg-primary);
    z-index: 10;
    border-bottom: 1px solid var(--ims-border-light);
  }
}

.sg-footer__social a {
  color: var(--ims-text-secondary);
  transition: color 0.2s ease, transform 0.2s ease;
}

.sg-footer__social a:hover {
  color: var(--ims-primary);
  transform: translateY(-2px);
}

.sg-footer__social svg {
  width: 24px;
  height: 24px;
}

/* Copyright */
.sg-footer__copyright {
  text-align: center;
  padding-top: var(--space-6);
  border-top: 1px solid var(--ims-border-light);
}

.sg-footer__copyright p {
  font-size: var(--text-xs);
  color: var(--ims-text-muted);
  margin: 0;
}

/* Footer Responsive */
@media (max-width: 640px) {
  .sg-footer__links {
    gap: var(--space-2);
  }
  
  .sg-footer__divider {
    display: none;
  }
  
  .sg-footer__social {
    flex-wrap: wrap;
    justify-content: center;
  }
}

/* ── Category Modal (early return — full-screen overlay) ── */
.sg-category-overlay {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background-color: #0F1F33;
  min-height: 100vh;
}

.sg-category-modal {
  background: #fff;
  width: 100%;
  max-width: 400px;
  border-radius: 1rem;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  overflow: hidden;
}

.sg-category-modal__header {
  padding: 1.25rem 1.5rem 1rem;
  border-bottom: 1px solid #f1f5f9;
}

.sg-category-modal__header h2 {
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 0.25rem;
}

.sg-category-modal__header p {
  font-size: 0.8125rem;
  color: #64748b;
  line-height: 1.5;
  margin: 0.25rem 0 0;
}

.sg-category-modal__dots {
  display: flex;
  gap: 0.375rem;
  margin-bottom: 0.75rem;
}

.sg-category-modal__dot {
  width: 0.375rem;
  height: 0.375rem;
  border-radius: 50%;
  background: #e2e8f0;
}

.sg-category-modal__dot--active {
  background: #1E3A5F;
}

.sg-category-modal__body {
  padding: 1.25rem 1.5rem;
}

.sg-category-modal__select {
  width: 100%;
  padding: 0.625rem 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  background: #fff;
  font-size: 0.875rem;
  color: #1e293b;
  outline: none;
  appearance: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.sg-category-modal__select:focus {
  border-color: #1E3A5F;
  box-shadow: 0 0 0 2px rgba(30, 58, 95, 0.1);
}

.sg-category-modal__warning {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-top: 0.875rem;
  padding: 0.625rem 0.75rem;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 0.5rem;
}

.sg-category-modal__warning svg {
  color: #d97706;
  flex-shrink: 0;
  margin-top: 0.125rem;
}

.sg-category-modal__warning p {
  font-size: 0.75rem;
  color: #92400e;
  line-height: 1.5;
  margin: 0;
}

.sg-category-modal__footer {
  display: flex;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid #f1f5f9;
}


.sg-category-modal__btn {
  flex: 1 1;
  padding: 0.625rem 1rem;
  border-radius: 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  transition: background-color 0.2s, opacity 0.2s;
  border: none;
}

.sg-category-modal__btn--primary {
  background: #1E3A5F;
  color: #fff;
}

.sg-category-modal__btn--primary:hover:not(:disabled) {
  background: #2D5A8E;
}

.sg-category-modal__btn--primary:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.sg-category-modal__btn--secondary {
  background: transparent;
  border: 1px solid #e2e8f0;
  color: #64748b;
}

.sg-category-modal__btn--secondary:hover:not(:disabled) {
  background: #f8fafc;
  color: #334155;
}

.sg-category-modal__selected {
  text-align: center;
  margin-bottom: 1.25rem;
}

.sg-category-modal__selected-label {
  display: block;
  font-size: 0.6875rem;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
  margin-bottom: 0.625rem;
}

.sg-category-modal__selected-value {
  display: inline-flex;
  padding: 0.625rem 1.25rem;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 0.75rem;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1E3A5F;
}

.sg-category-modal__danger {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 0.75rem;
  padding: 1rem;
}

.sg-category-modal__danger p {
  margin: 0;
  font-size: 0.875rem;
  color: #991b1b;
  line-height: 1.5;
}

.sg-category-modal__danger p:first-child {
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.sg-category-modal__danger p:last-child {
  font-size: 0.75rem;
  color: rgba(153, 27, 27, 0.85);
}

/* -------------------------------------------------------------------------
   Generation stepper (wait screen) — vertical 6-step ladder
   The checked ladder IS the progress; no percent numbers, no raw enums.
   ------------------------------------------------------------------------- */
.sg-stepper-wrap {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  box-sizing: border-box;
}

.sg-stepper {
  width: 100%;
  max-width: 560px;
  padding: 32px 36px;
  background: var(--ims-bg-primary);
  border: 1px solid var(--ims-border-light);
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
}

.sg-stepper__title {
  margin: 0 0 24px;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  color: var(--ims-text-primary);
}

.sg-stepper__list { list-style: none; margin: 0; padding: 0; }

.sg-step { position: relative; display: flex; gap: 14px; padding-bottom: 22px; }
.sg-step:last-child { padding-bottom: 0; }

/* connector line between step icons */
.sg-step:not(:last-child)::before {
  content: '';
  position: absolute;
  left: 11px; top: 26px; bottom: 2px;
  width: 2px;
  background: var(--ims-border-light);
}
.sg-step--done:not(:last-child)::before { background: var(--ims-primary); }

.sg-step__icon {
  flex: 0 0 24px;
  width: 24px; height: 24px;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 13px; font-weight: 700;
  background: var(--ims-border-light);
  color: var(--ims-text-secondary);
  z-index: 1;
}
.sg-step--done .sg-step__icon { background: var(--ims-primary); color: #fff; }
.sg-step--active .sg-step__icon { background: var(--ims-bg-primary); border: 2px solid var(--ims-primary); }
.sg-step--pending .sg-step__icon { background: var(--ims-bg-primary); border: 2px solid var(--ims-text-light); }

.sg-step__pulse {
  width: 10px; height: 10px;
  border-radius: 50%;
  background: var(--ims-primary);
  animation: sg-step-pulse 1.2s ease-in-out infinite;
}
@keyframes sg-step-pulse {
  0%, 100% { transform: scale(0.75); opacity: 0.6; }
  50% { transform: scale(1); opacity: 1; }
}

.sg-step__label { font-size: 14.5px; font-weight: 600; line-height: 24px; color: var(--ims-text-primary); }
.sg-step--pending .sg-step__label { color: var(--ims-text-muted); }
.sg-step__label-short { display: none; }

.sg-step__hint { margin: 4px 0 0; font-size: 13px; color: var(--ims-text-secondary); }

.sg-stepper__footer {
  margin: 24px 0 0;
  padding-top: 16px;
  border-top: 1px solid var(--ims-bg-secondary);
  text-align: center;
  font-size: 13px;
  color: var(--ims-text-secondary);
}

@media (max-width: 640px) {
  .sg-stepper-wrap { padding: 16px 12px; }
  .sg-stepper { padding: 24px 20px; }
  .sg-step__label-full { display: none; }
  .sg-step__label-short { display: inline; }
}


`, "",{"version":3,"sources":["webpack://./src/components/StatGenieReportCardV2.css"],"names":[],"mappings":";AACA,8CAA8C;;AAE9C;EACE,0FAA0F;EAC1F,mDAAmD;;EAEnD,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;;EAEpB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;;EAEvB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;;EAEnB,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;;EAEzB,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;;EAEtB,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;;EAE1B,4CAA4C;EAC5C,+EAA+E;EAC/E,gDAAgD;EAChD,+CAA+C;;EAE/C,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;;EAEhB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B;EAC9B,mCAAmC;EACnC,iBAAiB;;EAEjB;;;yDAGuD;EACvD,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA,4EAA4E;AAC5E;;;EAGE,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA,kBAAkB,sBAAsB,EAAE;;AAE1C,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,0CAA0C;EAC1C,+BAA+B;EAC/B,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,iCAAiC;EACjC,yCAAyC;EACzC,+BAA+B;EAC/B,0CAA0C;EAC1C,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;iEAEiE;AACjE;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA,mFAAmF;;AAEnF;;8EAE8E;AAC9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,oCAAoC;EACpC,cAAc;EACd,0CAA0C;EAC1C,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,YAAY,EAAE,8CAA8C;AAC9D;;AAEA;;4EAE4E;AAC5E;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;EAC/B,oCAAoC;EACpC,0CAA0C;EAC1C,wCAAwC;EACxC,8BAA8B;EAC9B,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,SAAS;AACX;;AAEA;;;oEAGoE;AACpE;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;4DAE4D;AAC5D;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gCAAgC,aAAa,EAAE;;AAE/C;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;;EAEE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;qDACqD;;AAErD,6BAA6B;AAC7B;EACE,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,MAAM;EACN,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA,4FAA4F;AAC5F;EACE,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gDAAgD;EAChD,sCAAsC;EACtC,gBAAgB;EAChB,MAAM;EACN,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,aAAa;AACf;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,+CAA+C;EAC/C,mCAAmC;EACnC,gBAAgB;EAChB,SAAS,EAAE,wBAAwB;EACnC,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,yCAAyC;EACzC,iCAAiC;EACjC,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,gCAAgC;AAClC;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,YAAY;EACZ,iCAAiC;EACjC,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;;oDAEoD;AACpD;EACE,aAAa;EACb,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,6CAA6C;EAC7C,2CAA2C;EAC3C,wBAAwB;EACxB,yDAAyD;EACzD,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;IACb,gDAAgD;IAChD,oBAAoB;EACtB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,iCAAiC;EACjC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,qDAAqD;AACvD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE;IACE,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA;2DAC2D;AAC3D;EACE,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;IAEE;IACA,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,aAAa;EACf;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,mBAAmB,EAAE,SAAS;IAC9B,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,WAAW;EACb;;EAEA,iCAAiC,aAAa,EAAE;EAChD,gCAAgC,eAAe,EAAE;;EAEjD;IACE,aAAa;EACf;;EAEA,sCAAsC;EACtC;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,oBAAoB;EACtB;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;;;;;;;EAQE,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,8BAA8B;EAC9B,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,cAAc,SAAS,EAAE,yBAAyB,EAAE,gBAAgB,EAAE;;AAEtE,sDAAsD;AACtD;EACE,yCAAyC;EACzC,mFAAmF;EACnF,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,8BAA8B;EAC9B,wBAAwB;EACxB,uBAAuB;EACvB,oCAAoC;EACpC,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,8BAA8B;EAC9B,wBAAwB;EACxB,sCAAsC;EACtC,uFAAuF;EACvF,+BAA+B;EAC/B,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;EAC3B,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA,sBAAsB,6BAA6B,EAAE;;AAErD;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;6FAC6F;AAC7F;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,iCAAiC;EACjC,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,oBAAoB,kCAAkC,EAAE,4BAA4B,EAAE;;AAEtF;EACE,6DAA6D;EAC7D,2CAA2C;AAC7C;;AAEA,gBAAgB,wCAAwC,EAAE;;AAE1D;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;;;EAIE,gCAAgC;EAChC,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA,mDAAmD;AACnD;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,sDAAsD;EACtD,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,yCAAyC;EACzC,+BAA+B;EAC/B,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,yBAAyB;EACzB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;mCAEmC;AACnC;;EAEE,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,MAAM;EACN,WAAW;EACX,cAAc;AAChB;AACA;;EAEE,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB,aAAa,EAAE,mBAAmB,EAAE;;AAExD;EACE,kCAAkC;EAClC,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;oBACoB,SAAS,EAAE,mCAAmC,EAAE;;AAEpE,sBAAsB,0BAA0B,EAAE;;AAElD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA,uCAAuC,mBAAmB,EAAE;AAC5D,gCAAgC,eAAe,EAAE,gBAAgB,EAAE;AACnE,+BAA+B,gCAAgC,EAAE;;AAEjE;EACE,oBAAoB;EACpB,kCAAkC;EAClC,+BAA+B;EAC/B,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,sCAAsC;EACtC,2CAA2C;EAC3C,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,eAAe,aAAa,EAAE,mBAAmB,EAAE;;AAEnD;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA,2BAA2B,gBAAgB,EAAE;;AAE7C,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,qEAAqE;EACrE,yCAAyC;EACzC,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,+BAA+B;EAC/B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA,+BAA+B,gBAAgB,EAAE;;AAEjD,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA,cAAc;AACd;EACE,qDAAqD;EACrD,yCAAyC;EACzC,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;AACF;AACA,mBAAmB,2BAA2B,EAAE;;AAEhD,iBAAiB,aAAa,EAAE,mBAAmB,EAAE;;AAErD;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;EAC5B,mBAAmB;EACnB,oDAAoD;EACpD,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,yCAAyC;EACzC,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,yCAAyC;EACzC,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;EAC9B,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,qBAAqB,aAAa,EAAE,mBAAmB,EAAE;;AAEzD;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA,mBAAmB,yBAAyB,EAAE,gBAAgB,EAAE;AAChE,sBAAsB,gCAAgC,EAAE,0BAA0B,EAAE;;AAEpF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,YAAY,4BAA4B,EAAE;;AAE1C;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,wBAAwB,gBAAgB,EAAE;AAC1C;EACE,gCAAgC;EAChC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,iBAAiB,cAAc,EAAE;;AAEjC;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,mCAAmC;EACnC,0DAA0D;EAC1D,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,4EAA4E;AAC5E;EACE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;EAClB;;wDAEsD;EACtD,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;;AAEA;0DAC0D;AAC1D;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,yDAAyD;AACzD;EACE,kCAAkC;AACpC;;AAEA,6BAA6B,mBAAmB,EAAE;;AAElD,gCAAgC;AAChC;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;0EAC0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE;IACE,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,aAAa;EACf;AACF;;AAEA,kCAAkC;AAClC;EACE,yCAAyC;EACzC,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;EAChB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA,sEAAsE;AACtE;EACE,oCAAoC;AACtC;;AAEA;EACE,yCAAyC;EACzC,mFAAmF;EACnF,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,mCAAmC;EACnC,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iCAAiC;EACjC,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;mFACmF;AACnF;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA,6CAA6C;AAC7C;EACE,0BAA0B;AAC5B;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,iFAAiF;EACjF,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;uEACuE;AACvE;EACE,kCAAkC;AACpC;;AAEA,6DAA6D;AAC7D;EACE,kCAAkC;AACpC;;AAEA,qDAAqD;;AAErD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,uCAAuC;AACzC;;AAEA;;;4EAG4E;AAC5E;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,4EAA4E;EAC5E,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,uEAAuE;AACvE;EACE;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;;AAEA,8DAA8D;;AAE9D;oEACoE;AACpE;;EAEE,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA,4EAA4E;;AAE5E,sFAAsF;AACtF;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,wCAAwC;AAC1C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,uCAAuC;EACvC,2CAA2C;AAC7C;AACA,sBAAsB,oBAAoB,EAAE;;AAE5C,gEAAgE;AAChE;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;AACA,oDAAoD,eAAe,EAAE;AACrE;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,iDAAiD;AACnD;AACA,8CAA8C,UAAU,EAAE;;AAE1D;yDACyD;AACzD;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,kCAAkC;AACpC;AACA;uEACuE;AACvE;;;sDAGsD,gBAAgB,EAAE;AACxE;EACE,8EAA8E;EAC9E,yCAAyC;AAC3C;;AAEA;kFACkF;AAClF;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;;AAEA;qEACqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,iCAAiC;EACjC,iCAAiC;EACjC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,6DAA6D;AAC/D;AACA;;EAEE,yBAAyB;EACzB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;oEACoE;AACpE;EACE,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,mCAAmC;EACnC,yCAAyC;EACzC,gCAAgC;EAChC,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;6FAE2F;EAC3F;;;IAGE,wBAAwB;EAC1B;;EAEA;;;IAGE,yBAAyB;EAC3B;;EAEA,yEAAyE;EACzE;IACE,6BAA6B;EAC/B;EACA;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,yBAAyB;IACzB,aAAa;EACf;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;6CAC6C;AAC7C;EACE;IACE,0BAA0B;IAC1B,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA,+EAA+E;;AAE/E;4DAC4D;AAC5D;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;;;AAIA;2EAC2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,aAAa;AACf;;AAEA;oEACoE;AACpE;EACE,YAAY;EACZ,cAAc;EACd,+CAA+C;EAC/C,gBAAgB;EAChB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA,gEAAgE;AAChE;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;qEACqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,8BAA8B;EAC9B,oCAAoC;EACpC,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;AACtB;AACA,4BAA4B,YAAY,EAAE;AAC1C,6BAA6B,YAAY,EAAE;AAC3C,4BAA4B,cAAc,EAAE;;AAE5C,uDAAuD;AACvD;EACE,6BAA6B;EAC7B;;6DAE2D;EAC3D,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,yCAAyC;EACzC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,oBAAoB;EACpB,iCAAiC;AACnC;AACA,qCAAqC,kCAAkC,EAAE;AACzE;EACE,kCAAkC;EAClC,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,uDAAuD;AACzD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;AACZ;;AAEA,8DAA8D;AAC9D;EACE,WAAW;EACX,sCAAsC;EACtC,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;AAClC;;AAEA,2EAA2E;AAC3E;EACE;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,gDAAgD;IAChD,SAAO;IACP,aAAa;EACf;EACA,sBAAsB,aAAa,EAAE;;EAErC,8EAA8E;EAC9E,oDAAoD,aAAa,EAAE;EACnE;IACE,cAAc;IACd,SAAO;IACP,aAAa;EACf;EACA,wDAAwD,oBAAoB,EAAE;EAC9E,qDAAqD,aAAa,EAAE;;EAEpE;IACE,eAAe;IACf,mBAAmB;EACrB;EACA,+CAA+C,eAAe,EAAE;;EAEhE;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA,iEAAiE;EACjE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gDAAgD;IAChD,SAAO;IACP,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA,2DAA2D;EAC3D;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,SAAO;IACP,aAAa;IACb,gBAAgB;EAClB;;EAEA,qDAAqD;EACrD;IACE,sBAAsB;IACtB,2DAA2D;EAC7D;;EAEA,sEAAsE;EACtE;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;;EAEA;mEACiE;EACjE;IACE,aAAa;IACb;;qBAEiB;IACjB,+BAA+B;IAC/B,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;EACvB;EACA,sEAAsE;EACtE;IACE,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,wBAAwB;IACxB,kBAAkB;IAClB,iCAAiC;IACjC,iCAAiC;IACjC,yBAAyB;IACzB,mDAAmD;IACnD,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,6DAA6D;AAC7D;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,oCAAoC;EACpC,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,oBAAoB,gCAAgC,EAAE,2BAA2B,EAAE;;AAEnF,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD;EACE,gBAAgB,uBAAuB,EAAE;EACzC,mBAAmB,0BAA0B,EAAE;EAC/C,mBAAmB,sBAAsB,EAAE,uBAAuB,EAAE;EACpE,4BAA4B,sBAAsB,EAAE;EACpD,qBAAqB,uBAAuB,EAAE;EAC9C,YAAY,gBAAgB,EAAE;AAChC;;AAEA;EACE;;;;;;IAME,wBAAwB;EAC1B;;EAEA;yCACuC;EACvC;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,yCAAyC;IACzC,wBAAmB;IAAnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,yCAAyC;EACzC,6CAA6C;EAC7C,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;EACE,wCAAwC;EACxC,wCAAwC;EACxC,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,8CAA8C;EAC9C,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,6CAA6C;AAC7C;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,2DAA2D,EAAE,wCAAwC;EACvG;;EAEA,0EAA0E;EAC1E;IACE,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA,qCAAqC;EACrC;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,iCAAiC;IACjC,WAAW;IACX,gDAAgD;EAClD;AACF;;AAEA;EACE,gCAAgC;EAChC,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA,8DAA8D;AAC9D;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,6BAA6B;AAC/B;;;AAGA;EACE,SAAO;EACP,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+CAA+C;EAC/C,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;;;8EAG8E;AAC9E;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,yCAAyC;EACzC,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,oBAAoB,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAE7D,WAAW,kBAAkB,EAAE,aAAa,EAAE,SAAS,EAAE,oBAAoB,EAAE;AAC/E,sBAAsB,iBAAiB,EAAE;;AAEzC,sCAAsC;AACtC;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU,EAAE,SAAS,EAAE,WAAW;EAClC,UAAU;EACV,mCAAmC;AACrC;AACA,0CAA0C,8BAA8B,EAAE;;AAE1E;EACE,cAAc;EACd,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe,EAAE,gBAAgB;EACjC,mCAAmC;EACnC,gCAAgC;EAChC,UAAU;AACZ;AACA,gCAAgC,8BAA8B,EAAE,WAAW,EAAE;AAC7E,kCAAkC,iCAAiC,EAAE,oCAAoC,EAAE;AAC3G,mCAAmC,iCAAiC,EAAE,uCAAuC,EAAE;;AAE/G;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,kDAAkD;AACpD;AACA;EACE,WAAW,sBAAsB,EAAE,YAAY,EAAE;EACjD,MAAM,mBAAmB,EAAE,UAAU,EAAE;AACzC;;AAEA,kBAAkB,iBAAiB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,8BAA8B,EAAE;AAC1G,oCAAoC,4BAA4B,EAAE;AAClE,wBAAwB,aAAa,EAAE;;AAEvC,iBAAiB,eAAe,EAAE,eAAe,EAAE,gCAAgC,EAAE;;AAErF;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB,kBAAkB,EAAE;EACvC,cAAc,kBAAkB,EAAE;EAClC,uBAAuB,aAAa,EAAE;EACtC,wBAAwB,eAAe,EAAE;AAC3C","sourcesContent":["\n/* Rebuilt from latest shared implementation */\n\n:root {\n  --font-primary: 'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  --font-mono: 'IBM Plex Mono', 'Consolas', monospace;\n\n  --text-xs: 0.75rem;\n  --text-sm: 0.875rem;\n  --text-base: 1rem;\n  --text-lg: 1.125rem;\n  --text-xl: 1.25rem;\n  --text-2xl: 1.5rem;\n  --text-3xl: 1.875rem;\n\n  --leading-tight: 1.25;\n  --leading-normal: 1.5;\n  --leading-relaxed: 1.75;\n\n  --ims-primary: #1E3A5F;\n  --ims-primary-light: #2D5A8E;\n  --ims-primary-dark: #0F1F33;\n  --ims-secondary: #4A90D9;\n  --ims-accent: #F59E0B;\n  --ims-success: #10B981;\n  --ims-warning: #F59E0B;\n  --ims-danger: #EF4444;\n  --ims-info: #3B82F6;\n\n  --ims-text-primary: #1F2937;\n  --ims-text-secondary: #6B7280;\n  --ims-text-muted: #9CA3AF;\n  --ims-text-light: #D1D5DB;\n\n  --ims-bg-primary: #FFFFFF;\n  --ims-bg-secondary: #F9FAFB;\n  --ims-bg-tertiary: #F3F4F6;\n  --ims-bg-card: #FFFFFF;\n\n  --ims-border-light: #E5E7EB;\n  --ims-border-medium: #D1D5DB;\n  --ims-border-dark: #9CA3AF;\n\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-card: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  --shadow-card-hover: 0 6px 14px rgba(0,0,0,0.08);\n  --shadow-lg: 0 16px 28px rgba(15, 31, 51, 0.12);\n\n  --space-1: 0.25rem;\n  --space-2: 0.5rem;\n  --space-3: 0.75rem;\n  --space-4: 1rem;\n  --space-5: 1.25rem;\n  --space-6: 1.5rem;\n  --space-8: 2rem;\n  --space-10: 2.5rem;\n  --space-12: 3rem;\n  --space-16: 4rem;\n\n  --radius-sm: 0.375rem;\n  --radius-md: 0.5rem;\n  --radius-lg: 0.75rem;\n  --radius-xl: 1rem;\n  --radius-2xl: 1.5rem;\n  --radius-full: 9999px;\n}\n\n.statgenie-v2 {\n  font-family: var(--font-primary);\n  font-size: var(--text-base);\n  line-height: var(--leading-normal);\n  color: var(--ims-text-primary);\n  background: var(--ims-bg-secondary);\n  min-height: 100vh;\n\n  /* Copy restriction: block text selection across the AI Insights report.\n     Why? Team requirement — report content must not be copyable.\n     CSS alone is not sufficient on all browsers; paired with onCopy/onCut\n     handlers on the root wrapper for defence in depth. */\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n/* Allow selection / typing inside form fields so the feedback form works. */\n.statgenie-v2 input,\n.statgenie-v2 textarea,\n.statgenie-v2 [contenteditable=\"true\"] {\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n}\n\n.statgenie-v2 * { box-sizing: border-box; }\n\n/* Top Navigation Bar */\n.sg-top-nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 1.5rem;\n  background: var(--ims-bg-primary);\n  border-bottom: 1px solid var(--ims-border-light);\n}\n\n.sg-top-nav__logo {\n  flex: 0 0 auto;\n}\n\n.sg-logo {\n  height: 50px;\n  width: auto;\n}\n\n.sg-top-nav__profile {\n  flex: 0 0 auto;\n  position: relative;\n}\n\n.sg-profile-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.5rem 0.75rem;\n  background: transparent;\n  border: 1px solid var(--ims-border-medium);\n  border-radius: var(--radius-md);\n  color: var(--ims-text-secondary);\n  font-size: var(--text-sm);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.sg-profile-btn:hover {\n  background: var(--ims-bg-tertiary);\n  color: var(--ims-text-primary);\n  border-color: var(--ims-border-dark);\n}\n\n.sg-profile-name-text {\n  text-transform: capitalize;\n}\n\n.sg-profile-dropdown {\n  position: absolute;\n  top: calc(100% + 0.5rem);\n  right: 0;\n  background: var(--ims-bg-primary);\n  border: 1px solid var(--ims-border-light);\n  border-radius: var(--radius-lg);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 200px;\n  z-index: 100;\n}\n\n.sg-profile-info {\n  padding: 1rem;\n}\n\n.sg-profile-name {\n  font-weight: 600;\n  font-size: var(--text-base);\n  color: var(--ims-text-primary);\n  margin-bottom: 0.5rem;\n}\n\n.sg-profile-detail {\n  font-size: var(--text-sm);\n  color: var(--ims-text-secondary);\n  margin-bottom: 0.25rem;\n}\n\n.sg-profile-divider {\n  height: 1px;\n  background: var(--ims-border-light);\n  margin: 0;\n}\n\n.sg-profile-action {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  background: transparent;\n  border: none;\n  color: var(--ims-text-primary);\n  font-size: var(--text-sm);\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.2s ease;\n}\n\n.sg-profile-action:hover {\n  background: var(--ims-bg-tertiary);\n}\n\n.sg-profile-logout {\n  color: var(--ims-danger);\n}\n\n.sg-profile-logout:hover {\n  background: #FEF2F2;\n}\n\n/* Report Header — title + BETA pill + tagline\n   Replaces legacy .sg-subheader inline strip. Kept the background token so it\n   still sits visually between the nav and the nav-pills/cards. */\n.sg-report-header {\n  padding: 1.25rem 1.5rem 1rem;\n  background: var(--ims-bg-tertiary);\n  border-bottom: 1px solid var(--ims-border-light);\n  text-align: center;\n}\n\n.sg-report-header__title {\n  margin: 0;\n  font-size: var(--text-2xl);\n  font-weight: 700;\n  line-height: var(--leading-tight);\n  color: var(--ims-primary);\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.sg-report-header__title-text {\n  letter-spacing: -0.01em;\n}\n\n.sg-report-header__tagline {\n  margin: 0.375rem 0 0;\n  font-size: var(--text-lg);\n  font-weight: 500;\n  color: var(--ims-text-secondary);\n  line-height: var(--leading-normal);\n}\n\n/* Removed desktop/mobile tagline split — copy is now identical (test name only). */\n\n/* BETA pill — amber tint of --ims-accent to stay in-system.\n   Why a tint instead of raw --ims-accent on white? Solid amber reads as\n   warning; a 15% tint reads as \"status notice\" which is exactly the intent. */\n.sg-beta-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: var(--radius-full);\n  font-size: 0.6875rem; /* 11px */\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  background: rgba(245, 158, 11, 0.15);\n  color: #92400E;\n  border: 1px solid rgba(245, 158, 11, 0.40);\n  text-transform: uppercase;\n  line-height: 1;\n  vertical-align: middle;\n  cursor: help; /* signals the native title tooltip on hover */\n}\n\n/* Beta info banner — left accent stripe + amber tint.\n   Why left stripe? Mirrors pattern used elsewhere in the app for informational\n   callouts, keeping this visually native rather than a one-off component. */\n.sg-beta-banner {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.625rem;\n  padding: 0.75rem 0.875rem;\n  margin: 0 0 var(--space-4);\n  border-radius: var(--radius-lg);\n  background: rgba(245, 158, 11, 0.08);\n  border: 1px solid rgba(245, 158, 11, 0.25);\n  border-left: 3px solid var(--ims-accent);\n  color: var(--ims-text-primary);\n  font-size: var(--text-sm);\n  line-height: var(--leading-normal);\n}\n\n.sg-beta-banner__icon {\n  flex-shrink: 0;\n  font-size: 1.125rem;\n  line-height: 1.25;\n}\n\n.sg-beta-banner__text {\n  flex: 1;\n  margin: 0;\n}\n\n/* Body wrapper holds the beta notice + What's new bullets stacked vertically.\n   Why a wrapper? The banner is a horizontal flex row (icon | body | close).\n   The body itself needs to stack vertically to show the notice followed by\n   the bullet list, so we wrap them in a column-flowing container. */\n.sg-beta-banner__body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n/* What's new sub-section — highlights student-facing changes between releases.\n   Visually subordinate to the beta notice (lighter heading, indented list)\n   so the beta context still reads as the primary message. */\n.sg-beta-banner__whats-new-title {\n  display: block;\n  font-weight: 600;\n  font-size: var(--text-sm);\n  margin-bottom: 0.25rem;\n}\n\n.sg-beta-banner__whats-new-list {\n  margin: 0;\n  padding-left: 1.25rem;\n  list-style: disc;\n}\n\n.sg-beta-banner__whats-new-list li {\n  margin-bottom: 0.25rem;\n  line-height: var(--leading-normal);\n}\n\n.sg-beta-banner__whats-new-list li:last-child {\n  margin-bottom: 0;\n}\n\n.sg-beta-banner__text--mobile { display: none; }\n\n.sg-beta-banner__close {\n  flex-shrink: 0;\n  background: transparent;\n  border: none;\n  color: var(--ims-text-muted);\n  font-size: 1.25rem;\n  line-height: 1;\n  padding: 0 0.25rem;\n  cursor: pointer;\n  transition: color 0.15s ease;\n  align-self: flex-start;\n}\n\n.sg-beta-banner__close:hover,\n.sg-beta-banner__close:focus {\n  color: var(--ims-text-primary);\n  outline: none;\n}\n\n/* Legacy .sg-subheader selectors removed — replaced by .sg-report-header.\n   Verified no external references before deletion. */\n\n/* Top-Level Tab Navigation */\n.sg-main-tab-nav-wrapper {\n  width: 100%;\n  background: var(--ims-bg-primary);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  border-bottom: 2px solid var(--ims-border-light);\n}\n\n.sg-main-tab-nav {\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n  gap: 0;\n  padding: 0;\n  background: var(--ims-bg-primary);\n}\n\n.sg-report-tab-anchor {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n}\n\n.sg-main-tab {\n  padding: 1rem 2.1rem;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  color: var(--ims-text-secondary);\n  font-size: 0.98rem;\n  font-weight: 650;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  margin-bottom: -2px;\n}\n\n.sg-main-tab:hover {\n  color: var(--ims-primary);\n  background: var(--ims-bg-secondary);\n}\n\n.sg-main-tab--active {\n  color: var(--ims-primary);\n  font-weight: 750;\n  border-bottom-color: var(--ims-primary);\n}\n\n/* Tab Content Container — matches .sg-container max-width for consistent feel across tabs */\n.sg-tab-content {\n  padding: var(--space-6);\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Evidence Library Full-Page Mode */\n.sg-library-fullpage {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  background: var(--ims-bg-primary);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-card);\n  overflow: visible;\n  display: flex;\n  flex-direction: column;\n}\n\n.sg-library-fullpage .sg-modal__header {\n  flex-shrink: 0;\n  border-bottom: 1px solid var(--ims-border-light);\n  padding: var(--space-4) var(--space-6);\n  position: sticky;\n  top: 0;\n  background: var(--ims-bg-primary);\n  z-index: 10;\n}\n\n.sg-library-fullpage .sg-modal__body {\n  flex: 1;\n  overflow: visible;\n  display: flex;\n  padding: 0;\n  min-height: 0;\n}\n\n.sg-library-fullpage .sg-library-nav {\n  width: 30%;\n  overflow-y: auto;\n  border-right: 1px solid var(--ims-border-light);\n  background: var(--ims-bg-secondary);\n  position: sticky;\n  top: 73px; /* Below sticky header */\n  align-self: flex-start;\n  max-height: calc(100vh - 73px);\n}\n\n.sg-library-fullpage .sg-library-content {\n  flex: 1;\n  overflow: visible;\n  padding: var(--space-6);\n}\n\n/* Navigation Pills - Desktop Only */\n.sg-nav-pills {\n  display: flex;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem;\n  background: var(--ims-bg-primary);\n  border-bottom: 1px solid var(--ims-border-light);\n}\n\n.sg-nav-pill {\n  padding: 0.5rem 1.25rem;\n  background: var(--ims-bg-tertiary);\n  border: 1px solid var(--ims-border-light);\n  border-radius: var(--radius-full);\n  color: var(--ims-text-secondary);\n  font-size: var(--text-sm);\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.sg-nav-pill:hover {\n  background: var(--ims-primary);\n  color: white;\n  border-color: var(--ims-primary);\n}\n\n/* Back to Top - Desktop */\n.sg-top-btn {\n  display: none;\n  position: fixed;\n  bottom: 1.5rem;\n  right: 1.5rem;\n  padding: 0.5rem 1rem;\n  background: var(--ims-primary);\n  border: none;\n  border-radius: var(--radius-full);\n  color: white;\n  font-size: var(--text-sm);\n  font-weight: 500;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  transition: all 0.2s ease;\n  z-index: 100;\n}\n\n.sg-top-btn--visible {\n  display: block;\n}\n\n.sg-top-btn:hover {\n  background: var(--ims-primary-light);\n  transform: translateY(-2px);\n}\n\n/* Mobile Bottom Tab Bar — 4-column grid, always visible.\n   Grid guarantees all 4 tabs fit without horizontal scrolling.\n   z-index 9999 ensures it sits above ALL content. */\n.sg-mobile-tab-bar {\n  display: none;\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100vw;\n  max-width: 100vw;\n  z-index: 9999;\n  background: rgba(255, 255, 255, 0.98);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border-top: 1px solid var(--ims-border-light);\n  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.10);\n  padding: 0.25rem 0.25rem;\n  padding-bottom: max(0.25rem, env(safe-area-inset-bottom));\n  overflow: hidden;\n}\n\n@media (max-width: 768px) {\n  .sg-mobile-tab-bar {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    align-items: stretch;\n  }\n}\n\n.sg-mobile-tab-bar__btn {\n  min-width: 0;\n  width: 100%;\n  padding: 0.38rem 0.15rem;\n  background: transparent;\n  border: none;\n  border-top: 2px solid transparent;\n  color: var(--ims-text-muted);\n  font-size: 0.68rem;\n  font-weight: 600;\n  font-family: inherit;\n  line-height: 1.05;\n  cursor: pointer;\n  white-space: normal;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  transition: color 0.15s ease, border-color 0.15s ease;\n}\n\n.sg-mobile-tab-bar__btn:hover {\n  color: var(--ims-text-secondary);\n}\n\n.sg-mobile-tab-bar__btn--active {\n  color: var(--ims-primary);\n  border-top-color: var(--ims-primary);\n  font-weight: 700;\n}\n\n/* Narrow mobile (<420px): further shrink tab bar text */\n@media (max-width: 420px) {\n  .sg-mobile-tab-bar__btn {\n    font-size: 0.625rem;\n    padding: 0.32rem 0.1rem;\n  }\n}\n\n/* Legacy .sg-float-menu — replaced by .sg-mobile-tab-bar, keeping for desktop\n   back-to-top only. Ensure it never shows on mobile now. */\n.sg-float-menu {\n  display: none;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .sg-top-nav {\n    padding: 0.75rem 1rem;\n  }\n\n  .sg-logo {\n    height: 40px;\n  }\n\n  .sg-profile-btn {\n    padding: 0.4rem 0.6rem;\n  }\n\n  .sg-profile-name-text {\n    display: none;\n  }\n\n    .sg-report-header {\n    padding: 1rem 1rem 0.875rem;\n  }\n\n  .sg-report-header__title {\n    font-size: var(--text-xl);\n    gap: 0.375rem;\n  }\n\n  .sg-report-header__tagline {\n    font-size: var(--text-base);\n    margin-top: 0.25rem;\n  }\n\n  .sg-beta-badge {\n    font-size: 0.625rem; /* 10px */\n    padding: 2px 7px;\n    letter-spacing: 0.05em;\n  }\n\n  .sg-beta-banner {\n    font-size: 0.8125rem;\n    padding: 0.625rem 0.75rem;\n    gap: 0.5rem;\n  }\n\n  .sg-beta-banner__text--desktop { display: none; }\n  .sg-beta-banner__text--mobile { display: inline; }\n\n  .sg-nav-pills {\n    display: none;\n  }\n\n  /* Hide desktop top button on mobile */\n  .sg-top-btn {\n    display: none !important;\n  }\n\n  .sg-container {\n    padding: var(--space-4);\n    padding-bottom: 5rem;\n  }\n}\n\n.sg-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: var(--space-6);\n}\n\n.sg-toolbar {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: var(--space-4);\n}\n\n.sg-print-btn,\n.sg-inline-toggle,\n.sg-tab,\n.sg-lens-toggle button,\n.sg-rating-btn,\n.sg-modal__close,\n.sg-accordion-header,\n.sg-table-card__header {\n  border: none;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.sg-print-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: var(--space-2) var(--space-4);\n  background: var(--ims-primary);\n  color: white;\n  border-radius: var(--radius-md);\n  font-size: var(--text-sm);\n  font-weight: 600;\n}\n\n.sg-card {\n  background: var(--ims-bg-card);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-card);\n  padding: var(--space-6);\n  margin-bottom: var(--space-4);\n}\n\n.sg-card h3 { margin: 0; font-size: var(--text-lg); font-weight: 650; }\n\n/* Next 2 Tests Plan - Stronger action block styling */\n.sg-next-steps {\n  border-left: 4px solid var(--ims-warning);\n  background: linear-gradient(to right, rgba(245, 158, 11, 0.03), var(--ims-bg-card));\n  box-shadow: var(--shadow-card-hover);\n}\n\n.sg-next-steps h3 {\n  color: var(--ims-primary);\n  font-size: var(--text-xl);\n  font-weight: 700;\n  margin-bottom: var(--space-3);\n}\n\n.sg-next-steps__priority {\n  font-size: var(--text-base);\n  font-weight: 600;\n  color: var(--ims-text-primary);\n  margin: var(--space-3) 0;\n  padding: var(--space-3);\n  background: rgba(245, 158, 11, 0.08);\n  border-radius: var(--radius-md);\n  border-left: 3px solid var(--ims-warning);\n}\n\n.sg-next-steps__area-priority {\n  font-size: var(--text-base);\n  font-weight: 650;\n  color: var(--ims-text-primary);\n  margin: var(--space-3) 0;\n  padding: var(--space-3) var(--space-4);\n  background: linear-gradient(135deg, rgba(16, 185, 129, 0.06), rgba(59, 130, 246, 0.04));\n  border-radius: var(--radius-md);\n  border-left: 4px solid #10b981;\n  box-shadow: 0 1px 3px rgba(16, 185, 129, 0.08);\n}\n\n.sg-next-steps__outcome {\n  font-size: var(--text-sm);\n  color: var(--ims-text-secondary);\n  margin-top: var(--space-4);\n  padding-top: var(--space-3);\n  border-top: 1px solid var(--ims-border-light);\n  font-style: italic;\n}\n\n.sg-overall-section { margin-bottom: var(--space-4); }\n\n.sg-sections-row {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: var(--space-4);\n  margin-bottom: var(--space-4);\n}\n\n.sg-top-card {\n  background: var(--ims-bg-card);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-card);\n  padding: var(--space-5);\n  border: 1px solid var(--ims-border-light);\n}\n\n.sg-top-card--overall {\n  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n}\n\n.sg-top-card__title {\n  font-size: var(--text-sm);\n  color: var(--ims-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  font-weight: 650;\n  margin-bottom: var(--space-2);\n}\n\n/* Section cards: reserve two title lines so percentile/marks rows align\n   across cards even when one title wraps (e.g. Quantitative Ability & Data Interpretation) */\n.sg-sections-row .sg-top-card__title {\n  line-height: 1.3;\n  min-height: 2.6em;\n}\n\n.sg-top-card__percentile {\n  font-size: clamp(1.5rem, 3.5vw, 2rem);\n  line-height: 1;\n  color: var(--ims-primary);\n  font-weight: 700;\n  margin-bottom: var(--space-1);\n}\n\n.sg-top-card__marks {\n  font-size: clamp(1.25rem, 2.5vw, 1.5rem);\n  font-weight: 700;\n  margin-bottom: var(--space-4);\n}\n\n.sg-readiness-row--iimb {\n  padding-top: var(--space-3);\n  border-top: 1px solid var(--ims-border-light);\n}\n\n.sg-readiness-row__label--iimb {\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.sg-readiness-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-3);\n}\n\n.sg-readiness-row__label {\n  font-size: var(--text-sm);\n  color: var(--ims-text-secondary);\n  flex-shrink: 0;\n}\n\n.sg-pill {\n  display: inline-block;\n  padding: var(--space-1) var(--space-3);\n  border-radius: var(--radius-full);\n  font-size: var(--text-xs);\n  font-weight: 650;\n  text-align: right;\n}\n\n.sg-pill--success { background: #D1FAE5; color: #065F46; }\n.sg-pill--danger { background: #FEE2E2; color: #991B1B; }\n.sg-pill--neutral { background: var(--ims-bg-tertiary); color: var(--ims-text-muted); }\n\n.sg-summary-card {\n  background: linear-gradient(135deg, #F0F9FF 0%, #E0F2FE 100%);\n  border-left: 4px solid var(--ims-secondary);\n}\n\n.sg-goal-card { border-top: 4px solid var(--ims-primary); }\n\n.sg-goal-card__title {\n  margin-top: var(--space-4);\n  font-size: var(--text-xl);\n  font-weight: 700;\n  color: var(--ims-primary);\n}\n\n.sg-goal-card__why,\n.sg-goal-card__focus,\n.sg-goal-card__impact,\n.sg-block-copy {\n  color: var(--ims-text-secondary);\n  line-height: var(--leading-relaxed);\n  margin: var(--space-3) 0 0;\n}\n\n/* S3 — deterministic overall-contribution closer */\n.sg-goal-card__impact {\n  padding-top: var(--space-3);\n  margin-top: var(--space-4);\n  border-top: 1px solid var(--ims-border-light, #e5e7eb);\n  color: var(--ims-text-primary);\n  font-weight: 500;\n}\n\n.sg-block-header {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--space-4);\n  align-items: flex-start;\n  margin-bottom: var(--space-4);\n}\n\n.sg-lens-toggle {\n  display: inline-flex;\n  background: rgba(255,255,255,0.66);\n  border: 1px solid var(--ims-border-light);\n  border-radius: var(--radius-md);\n  padding: 2px;\n  gap: 2px;\n}\n\n.sg-lens-toggle button {\n  padding: var(--space-2) var(--space-3);\n  border-radius: calc(var(--radius-md) - 2px);\n  font-size: var(--text-sm);\n  background: transparent;\n  color: var(--ims-text-secondary);\n}\n\n.sg-lens-toggle button.active {\n  background: var(--ims-bg-primary);\n  color: var(--ims-primary);\n  box-shadow: var(--shadow-sm);\n  font-weight: 650;\n}\n\n/* Evidence Library toggles — pill style matching Skill Meter baseline.\n   Scoped to .sg-modal / .sg-library-fullpage so the report page toggle\n   (in .sg-card) stays unchanged. */\n.sg-modal .sg-lens-toggle,\n.sg-library-fullpage .sg-lens-toggle {\n  display: inline-flex;\n  border: 1px solid #d1d8e0;\n  border-radius: 999px;\n  overflow: hidden;\n  background: #fff;\n  padding: 0;\n  gap: 0;\n  width: auto;\n  flex-shrink: 0;\n}\n.sg-modal .sg-lens-toggle button,\n.sg-library-fullpage .sg-lens-toggle button {\n  padding: 7px 12px;\n  border: 0;\n  background: #fff;\n  color: #374151;\n  font-size: 12px;\n  font-weight: 800;\n  cursor: pointer;\n  font-family: inherit;\n  border-radius: 0;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.sg-modal .sg-lens-toggle button.active,\n.sg-library-fullpage .sg-lens-toggle button.active {\n  background: #111827;\n  color: #fff;\n  box-shadow: none;\n  font-weight: 800;\n}\n\n.sg-summary-zones { display: grid; gap: var(--space-4); }\n\n.sg-summary-zone {\n  background: rgba(255,255,255,0.65);\n  border: 1px solid rgba(255,255,255,0.8);\n  border-radius: var(--radius-lg);\n  padding: var(--space-4);\n}\n\n.sg-zone-label {\n  font-size: var(--text-xs);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--ims-text-muted);\n  font-weight: 700;\n  margin-bottom: var(--space-2);\n}\n\n.sg-summary-zone p,\n.sg-priority-item { margin: 0; line-height: var(--leading-relaxed); }\n\n.sg-summary-actions { margin-top: var(--space-4); }\n\n.sg-inline-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  background: transparent;\n  color: var(--ims-primary);\n  font-weight: 650;\n  padding: 0;\n}\n\n.sg-tier-performance {\n  background: var(--ims-bg-secondary);\n  border-radius: var(--radius-md);\n  padding: var(--space-4);\n}\n\n.sg-tier-performance h4 {\n  margin: 0 0 var(--space-3);\n  font-size: var(--text-sm);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--ims-text-secondary);\n}\n\n.sg-tier-performance__row {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-2);\n  padding: var(--space-2) 0;\n  border-bottom: 1px solid var(--ims-border-light);\n}\n\n.sg-tier-performance__row:last-child { border-bottom: none; }\n.sg-tier-performance__section { min-width: 64px; font-weight: 650; }\n.sg-tier-performance__detail { color: var(--ims-text-secondary); }\n\n.sg-tabs {\n  display: inline-flex;\n  background: var(--ims-bg-tertiary);\n  border-radius: var(--radius-lg);\n  padding: 4px;\n  gap: 4px;\n}\n\n.sg-tab {\n  background: transparent;\n  color: var(--ims-text-secondary);\n  padding: var(--space-2) var(--space-4);\n  border-radius: calc(var(--radius-lg) - 4px);\n  font-size: var(--text-sm);\n  font-weight: 600;\n}\n\n.sg-tab--active {\n  background: var(--ims-bg-primary);\n  color: var(--ims-primary);\n  box-shadow: var(--shadow-sm);\n}\n\n.sg-findings { display: grid; gap: var(--space-4); }\n\n.sg-finding {\n  border: 1px solid var(--ims-border-light);\n  border-radius: var(--radius-lg);\n  padding: var(--space-4);\n  background: #FCFCFD;\n}\n\n.sg-finding__text {\n  color: var(--ims-text-primary);\n  line-height: var(--leading-relaxed);\n  margin-bottom: var(--space-2);\n}\n\n.sg-finding__text strong { font-weight: 650; }\n\n/* Section Panel - Restructured Layout */\n.sg-section-panel {\n  display: grid;\n  gap: var(--space-6);\n  padding: var(--space-4);\n}\n\n/* Strategy Context */\n.sg-strategy-context {\n  background: linear-gradient(135deg, var(--ims-bg-secondary), #F0F4F8);\n  border-left: 4px solid var(--ims-primary);\n  border-radius: var(--radius-lg);\n  padding: var(--space-5);\n}\n\n.sg-strategy-context__label {\n  font-size: var(--text-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--ims-primary);\n  margin-bottom: var(--space-2);\n}\n\n.sg-strategy-context__text {\n  color: var(--ims-text-primary);\n  line-height: var(--leading-relaxed);\n  font-size: var(--text-base);\n}\n\n/* Findings Grid - Two Column Layout */\n.sg-findings-grid {\n  display: grid;\n  gap: var(--space-4);\n}\n\n.sg-finding-row {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  gap: var(--space-4);\n  align-items: start;\n  border: 1px solid var(--ims-border-light);\n  border-radius: var(--radius-lg);\n  padding: var(--space-4);\n  background: var(--ims-bg-card);\n}\n\n.sg-finding-row__label {\n  font-size: var(--text-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--ims-text-secondary);\n  padding-top: var(--space-1);\n}\n\n.sg-finding-row__content {\n  display: grid;\n  gap: var(--space-2);\n}\n\n.sg-finding-row__text {\n  color: var(--ims-text-primary);\n  line-height: var(--leading-relaxed);\n}\n\n.sg-finding-row__text strong { font-weight: 650; }\n\n/* Finding Row Actions - Dual Buttons */\n.sg-finding-row__actions {\n  display: flex;\n  gap: var(--space-3);\n  flex-wrap: wrap;\n  margin-top: var(--space-2);\n}\n\n.sg-inline-toggle--secondary {\n  background: transparent;\n  color: var(--ims-text-secondary);\n  border: 1px solid var(--ims-border-light);\n}\n\n.sg-inline-toggle--secondary:hover {\n  background: var(--ims-bg-secondary);\n  color: var(--ims-text-primary);\n}\n\n/* Next Step */\n.sg-next-step {\n  background: linear-gradient(135deg, #F0FDF4, #DCFCE7);\n  border-left: 4px solid var(--ims-success);\n  border-radius: var(--radius-lg);\n  padding: var(--space-5);\n}\n\n.sg-next-step__label {\n  font-size: var(--text-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--ims-success);\n  margin-bottom: var(--space-2);\n}\n\n.sg-next-step__text {\n  color: var(--ims-text-primary);\n  line-height: var(--leading-relaxed);\n  font-weight: 500;\n}\n\n/* Mobile Responsive */\n@media (max-width: 640px) {\n  .sg-finding-row {\n    grid-template-columns: 1fr;\n    gap: var(--space-2);\n  }\n  \n  .sg-finding-row__label {\n    padding-top: 0;\n  }\n}\n.sg-evidence-ref { color: var(--ims-secondary); }\n\n.sg-priorities { display: grid; gap: var(--space-3); }\n\n.sg-priority-item {\n  padding: var(--space-3) var(--space-4);\n  border-radius: var(--radius-md);\n  background: var(--ims-bg-secondary);\n}\n\n.sg-rating-card {\n  text-align: center;\n  padding: var(--space-4) var(--space-5);\n  max-width: 1200px;\n  margin: 0 auto;\n  background: transparent;\n  box-shadow: none;\n  border-radius: 0;\n  border-top: 1px solid var(--ims-border-light);\n  margin-top: var(--space-4);\n}\n\n.sg-rating-subtitle {\n  color: var(--ims-text-secondary);\n  font-size: var(--text-sm);\n  margin-top: var(--space-2);\n}\n\n.sg-rating-stars {\n  margin: var(--space-4) 0;\n}\n\n.sg-rating-stars__row {\n  display: flex;\n  justify-content: center;\n  gap: var(--space-2);\n  margin-bottom: var(--space-2);\n}\n\n.sg-rating-star {\n  font-size: 2.5rem;\n  line-height: 1;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n  color: var(--ims-accent);\n}\n\n.sg-rating-star:hover {\n  transform: scale(1.1);\n}\n\n.sg-rating-text {\n  color: var(--ims-text-secondary);\n  font-size: var(--text-sm);\n  margin: 0;\n}\n\n.sg-rating-details {\n  border-top: 1px solid var(--ims-border-light);\n  padding-top: var(--space-4);\n  margin-top: var(--space-4);\n}\n\n.sg-rating-details--visible {\n  border-left: 3px solid var(--ims-primary);\n  padding-left: var(--space-4);\n  background: #f8fafc;\n  border-radius: 0 var(--radius-lg) var(--radius-lg) 0;\n  animation: sg-fadeIn 0.3s ease-out;\n}\n\n@keyframes sg-fadeIn {\n  from { opacity: 0; transform: translateY(6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.sg-rating-question {\n  color: var(--ims-text-primary);\n  font-size: var(--text-sm);\n  font-weight: 500;\n  margin-bottom: var(--space-3);\n}\n\n.sg-rating-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-2);\n  justify-content: center;\n  margin-bottom: var(--space-4);\n}\n\n.sg-rating-tag {\n  padding: var(--space-2) var(--space-3);\n  background: var(--ims-bg-tertiary);\n  border: 1px solid var(--ims-border-light);\n  border-radius: var(--radius-full);\n  color: var(--ims-text-primary);\n  font-size: var(--text-sm);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.sg-rating-tag:hover {\n  background: var(--ims-border-light);\n}\n\n.sg-rating-tag--selected {\n  background: var(--ims-primary);\n  color: white;\n  border-color: var(--ims-primary);\n}\n\n.sg-rating-comment {\n  width: 100%;\n  padding: var(--space-3);\n  background: #fff;\n  border: 1px solid var(--ims-border-light);\n  border-radius: var(--radius-lg);\n  color: var(--ims-text-primary);\n  font-size: var(--text-sm);\n  font-family: inherit;\n  resize: none;\n  margin-bottom: var(--space-4);\n}\n\n.sg-rating-comment::placeholder {\n  color: var(--ims-text-secondary);\n  opacity: 0.8;\n}\n\n.sg-rating-comment:focus {\n  outline: none;\n  border-color: var(--ims-primary);\n}\n\n.sg-rating-submit {\n  padding: var(--space-3) var(--space-6);\n  background: var(--ims-primary);\n  border: none;\n  border-radius: var(--radius-lg);\n  color: white;\n  font-size: var(--text-base);\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.sg-rating-submit:hover {\n  background: var(--ims-primary-light);\n}\n\n.sg-rating-submit:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.sg-rating-success {\n  color: var(--ims-success);\n  font-weight: 600;\n  padding: var(--space-4);\n}\n\n.sg-accordion-list { display: grid; gap: var(--space-3); }\n\n.sg-accordion-item {\n  border: 1px solid var(--ims-border-light);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.sg-accordion-header {\n  width: 100%;\n  background: var(--ims-bg-secondary);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--space-4);\n  color: var(--ims-text-primary);\n  font-weight: 650;\n}\n\n.sg-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 31, 51, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-6);\n  z-index: 1000;\n}\n\n.sg-modal {\n  width: min(980px, 100%);\n  max-height: 88vh;\n  overflow: hidden;\n  background: white;\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-lg);\n  display: flex;\n  flex-direction: column;\n}\n\n.sg-modal__header {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--space-4);\n  padding: var(--space-5) var(--space-6);\n  border-bottom: 1px solid var(--ims-border-light);\n}\n\n.sg-modal__title { font-size: var(--text-lg); font-weight: 700; }\n.sg-modal__subtitle { color: var(--ims-text-secondary); margin-top: var(--space-1); }\n\n.sg-modal__header-actions {\n  display: flex;\n  gap: var(--space-3);\n  align-items: flex-start;\n}\n\n.sg-modal__close {\n  background: transparent;\n  color: var(--ims-text-secondary);\n  padding: var(--space-2);\n  border-radius: var(--radius-md);\n}\n\n.sg-modal__body {\n  padding: var(--space-5) var(--space-6);\n  overflow: auto;\n  display: grid;\n  gap: var(--space-4);\n}\n\n.sg-empty { color: var(--ims-text-muted); }\n\n.sg-table-card {\n  border: 1px solid var(--ims-border-light);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.sg-table-card__header {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-4);\n  background: var(--ims-bg-secondary);\n  padding: var(--space-4);\n  text-align: left;\n}\n\n.sg-table-card__title { font-weight: 650; }\n.sg-table-card__subtitle {\n  color: var(--ims-text-secondary);\n  font-size: var(--text-sm);\n  margin-top: var(--space-1);\n}\n\n.sg-table-wrap { overflow: auto; }\n\n.sg-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--text-sm);\n}\n\n.sg-table th {\n  text-align: center;\n  padding: var(--space-3) var(--space-4);\n  background: var(--ims-bg-secondary);\n  border-bottom: 2px solid var(--ims-primary-light, #2D5A8E);\n  color: var(--ims-primary);\n  font-size: var(--text-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n/* First header column — section/test/area names should stay left-aligned. */\n.sg-table th:first-child {\n  text-align: left;\n}\n\n.sg-table td {\n  padding: var(--space-3) var(--space-4);\n  border-bottom: 1px solid var(--ims-border-light);\n  vertical-align: top;\n  text-align: center;\n  /* Preserve \\n line breaks in multiline cells (e.g. \"71.4%\\n40.0%\").\n     Desktop cells use CSS pre-line; mobile cards use explicit <span> stacking\n     via renderCellValue() for tighter layout control. */\n  white-space: pre-line;\n}\n\n.sg-cell--multiline {\n  display: flex;\n  flex-direction: column;\n}\n.sg-cell--multiline-line {\n  display: block;\n}\n\n/* Label column (first): left-aligned, allow text wrapping with max-width\n   to prevent long names from squeezing numeric columns. */\n.sg-table td:first-child {\n  text-align: left;\n  max-width: 180px;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n\n/* Row hover — subtle background shift for scannability */\n.sg-table tbody tr:hover td {\n  background: rgba(30, 58, 95, 0.04);\n}\n\n.sg-table tr:last-child td { border-bottom: none; }\n\n/* Simple Pattern Table Styles */\n.sg-table--simple-pattern {\n  font-size: var(--text-base);\n}\n\n.sg-table--simple-pattern td {\n  padding: var(--space-4);\n  vertical-align: middle;\n}\n\n.sg-status-cleared {\n  color: var(--ims-success);\n  font-weight: 600;\n}\n\n.sg-status-missed {\n  color: var(--ims-danger);\n  font-weight: 600;\n}\n\n/* Evidence Table Styles */\n.sg-evidence-table {\n  width: 100%;\n}\n\n.sg-evidence-table__header {\n  margin-bottom: var(--space-4);\n}\n\n.sg-evidence-table__title {\n  font-size: var(--text-lg);\n  font-weight: 650;\n  color: var(--ims-text-primary);\n}\n\n.sg-evidence-table__subtitle {\n  color: var(--ims-text-secondary);\n  font-size: var(--text-sm);\n  margin-top: var(--space-1);\n}\n\n.sg-evidence-table__desktop {\n  overflow-x: auto;\n}\n\n.sg-evidence-table__mobile {\n  display: none;\n}\n\n.sg-evidence-table__source {\n  margin-top: var(--space-4);\n}\n\n/* Source disclosure toggle — always visible. On desktop it auto-expands;\n   CSS below hides the button on wide screens and shows the text inline. */\n.sg-evidence-table__source-toggle {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 0;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: var(--ims-text-muted);\n  font-size: var(--text-xs);\n  font-family: inherit;\n  transition: color 0.15s ease;\n}\n.sg-evidence-table__source-toggle:hover {\n  color: var(--ims-text-secondary);\n}\n.sg-evidence-table__source-chevron {\n  display: inline-block;\n  font-size: 10px;\n  transition: transform 0.15s ease;\n  line-height: 1;\n}\n.sg-evidence-table__source-chevron--open {\n  transform: rotate(180deg);\n}\n.sg-evidence-table__source-text {\n  margin-top: 4px;\n  font-size: var(--text-xs);\n  font-style: italic;\n  color: var(--ims-text-muted);\n  line-height: 1.5;\n}\n\n/* Desktop: show source text inline (no toggle needed). */\n@media (min-width: 769px) {\n  .sg-evidence-table__source-toggle {\n    display: none;\n  }\n  .sg-evidence-table__source-text {\n    display: block !important;\n    margin-top: 0;\n  }\n}\n\n/* Evidence Card Styles (Mobile) */\n.sg-evidence-card {\n  border: 1px solid var(--ims-border-light);\n  border-left: 3px solid #d1d5db;\n  border-radius: var(--radius-lg);\n  margin-bottom: var(--space-3);\n  overflow: hidden;\n  background: var(--ims-bg-card);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n/* Zebra: alternate cards get a faint tint for vertical scanability. */\n.sg-evidence-table__mobile .sg-evidence-card:nth-child(even) {\n  background: rgba(248, 250, 252, 0.7);\n}\n\n.sg-evidence-card--highlight {\n  border-left: 4px solid var(--ims-primary);\n  background: linear-gradient(90deg, rgba(30, 58, 95, 0.06), var(--ims-bg-card) 12px);\n  box-shadow: 0 1px 4px rgba(30, 58, 95, 0.08);\n}\n\n.sg-evidence-card__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: var(--space-2);\n  padding: var(--space-3) var(--space-4);\n  background: var(--ims-bg-secondary);\n  border-bottom: 1px solid var(--ims-border-light);\n}\n\n.sg-evidence-card__title {\n  font-weight: 700;\n  color: var(--ims-text-primary);\n  font-size: 0.9375rem;\n}\n\n.sg-evidence-card__subtitle {\n  font-size: var(--text-xs);\n  color: var(--ims-text-secondary);\n  margin-top: var(--space-1);\n  font-weight: 500;\n}\n\n.sg-evidence-card__badge {\n  font-size: var(--text-xs);\n  padding: 2px 8px;\n  border-radius: var(--radius-full);\n  background: var(--ims-primary);\n  color: white;\n  font-weight: 500;\n}\n\n.sg-evidence-card__body {\n  padding: var(--space-3) var(--space-4);\n  background: #fff;\n}\n\n/* Two-column paired row layout — each pair holds 2 label-value cells\n   side by side. On ≤420px (see narrow mobile block), collapses to single column. */\n.sg-evidence-card__row-pair {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4px 12px;\n  padding: var(--space-2) 0;\n  border-bottom: 1px solid #f3f4f6;\n}\n.sg-evidence-card__row-pair:last-child {\n  border-bottom: none;\n}\n/* Odd item: single cell spans both columns */\n.sg-evidence-card__row-pair--single {\n  grid-template-columns: 1fr;\n}\n\n/* Individual cell within a row-pair — label above value */\n.sg-evidence-card__cell {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.sg-evidence-card__label {\n  font-size: var(--text-xs);\n  color: var(--ims-text-muted);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sg-evidence-card__value {\n  font-size: var(--text-sm);\n  font-weight: 600;\n  color: var(--ims-text-primary);\n  text-align: left;\n  /* Preserve \\n line breaks rendered by renderMobileCellValue() stacked <span>s. */\n  white-space: pre-line;\n  line-height: 1.35;\n}\n\n/* Subtle zebra striping for evidence tables (row count > 2).\n   Tint at 4% for visible but non-competitive horizontal scaffolding. */\n.sg-table tbody tr:nth-child(even) td {\n  background: rgba(30, 58, 95, 0.04);\n}\n\n/* Table row highlight — current-test / first-row emphasis. */\n.sg-table__row--highlight td {\n  background: rgba(30, 58, 95, 0.08);\n}\n\n/* --- Useful Insights (_ai_meta) 2-column grid --- */\n\n.sg-useful-insights {\n  margin-top: 16px;\n  padding: 12px 14px;\n  background: #f6f8fa;\n  border: 1px solid #e1e4e8;\n  border-radius: 8px;\n  font-size: 13px;\n  color: #24292e;\n}\n\n.sg-useful-insights__title {\n  font-weight: 600;\n  margin-bottom: 8px;\n  font-size: 13px;\n  color: var(--ims-text-primary, #1f2937);\n}\n\n/* 2-column grid — items auto-flow into two equal columns.\n   Why 2 columns? The _ai_meta panel can produce 10+ bullets;\n   stacking them in a single column elongates the modal unnecessarily.\n   Two columns halve the vertical height while keeping each item readable. */\n.sg-useful-insights__grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4px 20px;\n}\n\n.sg-useful-insights__item {\n  font-size: 13px;\n  line-height: 1.5;\n  padding: 2px 0;\n  /* Bullet via CSS pseudo-element (cleaner than <ul>/<li> for grid layout). */\n  padding-left: 14px;\n  position: relative;\n}\n.sg-useful-insights__item::before {\n  content: '•';\n  position: absolute;\n  left: 0;\n  color: var(--ims-text-muted, #9ca3af);\n}\n\n.sg-useful-insights__count {\n  color: #586069;\n}\n\n.sg-useful-insights__detail {\n  color: var(--ims-text-secondary, #4b5563);\n}\n\n/* Mobile: collapse to 1 column (narrow screens can't fit 2 columns). */\n@media (max-width: 640px) {\n  .sg-useful-insights__grid {\n    grid-template-columns: 1fr;\n    gap: 2px 0;\n  }\n}\n\n/* --- Mobile readiness cell sub-lines (Option C layout) --- */\n\n/* Scored / Cutoff lines in mobile evidence cards — slightly smaller and muted\n   so the status line (e.g. \"❌ MISSED\") remains the visual anchor. */\n.sg-cell--readiness-scored,\n.sg-cell--readiness-cutoff {\n  font-size: 0.92em;\n  color: var(--ims-text-secondary, #4b5563);\n}\n\n/* --- Backported from audit-viewer WAVE 2 ------------------------------- */\n\n/* Clickable sort header (cursor + hover affordance only on actually-clickable ths). */\n.sg-table__th--sortable {\n  cursor: pointer;\n  user-select: none;\n  transition: background 0.12s ease-in-out;\n}\n.sg-table__th--sortable:hover {\n  background: var(--ims-bg-tertiary, #eef2f7);\n}\n.sg-table__th--active {\n  color: var(--ims-text-primary, #1a1a1a);\n  background: var(--ims-bg-tertiary, #eef2f7);\n}\n.sg-table__th-label { margin-right: 0.35em; }\n\n/* Multi-line <th>: '\\n' in column label → stacked sub-labels. */\n.sg-table__th--multiline .sg-table__th-label {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  line-height: 1.2;\n  vertical-align: middle;\n}\n.sg-table__th-label-primary {\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n.sg-table__th-label-sub {\n  font-size: 0.85em;\n  font-weight: 600;\n  color: var(--ims-text-secondary, #4b5563);\n  text-transform: none;\n  letter-spacing: 0;\n  margin-top: 2px;\n  cursor: help;\n}\n.sg-table__th-label-sub + .sg-table__th-label-sub { margin-top: 1px; }\n.sg-table__th-chevron {\n  display: inline-block;\n  min-width: 0.9em;\n  font-size: 0.85em;\n  opacity: 0.5;\n  font-family: system-ui, -apple-system, sans-serif;\n}\n.sg-table__th--active .sg-table__th-chevron { opacity: 1; }\n\n/* Group-total row ('Overall' heuristic) — prominent border-top + bolder weight\n   to clearly separate aggregate data from detail rows. */\n.sg-table__row--overall td {\n  font-weight: 650;\n  border-top: 1.5px solid var(--ims-primary);\n  background: rgba(30, 58, 95, 0.08);\n}\n/* Mobile counterpart on evidence cards — Overall rows get a subtle primary-tinted background\n   and heavier weight to distinguish them from data rows at a glance. */\n.sg-evidence-card--overall .sg-evidence-card__title,\n.sg-evidence-card--overall .sg-evidence-card__subtitle,\n.sg-evidence-card--overall .sg-evidence-card__value,\n.sg-evidence-card--overall .sg-evidence-card__label { font-weight: 650; }\n.sg-evidence-card--overall {\n  background: linear-gradient(90deg, rgba(30, 58, 95, 0.05), var(--ims-bg-card));\n  border-left: 3px solid var(--ims-primary);\n}\n\n/* Multi-line subtitle variant: when backend emits a '\\n'-joined subtitle,\n   stack as a centered, prominent mini-scoreboard. Single-line keeps quiet tone. */\n.sg-evidence-table__subtitle--multiline {\n  text-align: center;\n  font-size: var(--text-base);\n  font-weight: 600;\n  color: var(--ims-text-primary);\n  margin-top: var(--space-3);\n  line-height: 1.5;\n}\n.sg-evidence-table__subtitle--multiline .sg-evidence-table__subtitle-line + .sg-evidence-table__subtitle-line {\n  margin-top: var(--space-1);\n}\n\n/* Title row — centered title with an optional subtle ⓘ button.\n   Click expands a readable purpose panel below. No hover tooltips. */\n.sg-evidence-table__title-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n}\n\n.sg-evidence-table__info-btn {\n  width: 24px;\n  height: 24px;\n  border: 1px solid var(--ims-border-light);\n  border-radius: var(--radius-full);\n  background: var(--ims-bg-primary);\n  color: var(--ims-text-muted);\n  font-size: 0.85rem;\n  font-weight: 700;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: color 0.15s, border-color 0.15s, background 0.15s;\n}\n.sg-evidence-table__info-btn:hover,\n.sg-evidence-table__info-btn--active {\n  color: var(--ims-primary);\n  border-color: var(--ims-primary);\n  background: rgba(30, 58, 95, 0.06);\n}\n\n/* Purpose panel — readable, full-width below the title row.\n   Centered, constrained, pleasant background. Appears on ⓘ click. */\n.sg-evidence-table__purpose-panel {\n  margin: 0.75rem auto 0;\n  max-width: 760px;\n  padding: 0.75rem 1rem;\n  border-radius: var(--radius-lg);\n  background: var(--ims-bg-secondary);\n  border: 1px solid var(--ims-border-light);\n  color: var(--ims-text-secondary);\n  font-size: var(--text-sm);\n  line-height: 1.55;\n  text-align: left;\n}\n\n/* Mobile: Show card layout, hide table */\n@media (max-width: 768px) {\n  .sg-evidence-table__desktop {\n    display: none !important;\n  }\n\n  .sg-evidence-table__mobile {\n    display: block !important;\n  }\n\n  /* Explicitly force card view inside the Evidence Library full-page and modal containers.\n     Why: the library's own pane toggling (nav↔content) can create stacking contexts where\n     the desktop table re-emerges. These rules override that so cards always win on mobile. */\n  .sg-library-fullpage .sg-evidence-table__desktop,\n  .sg-library-content .sg-evidence-table__desktop,\n  .sg-modal__body .sg-evidence-table__desktop {\n    display: none !important;\n  }\n\n  .sg-library-fullpage .sg-evidence-table__mobile,\n  .sg-library-content .sg-evidence-table__mobile,\n  .sg-modal__body .sg-evidence-table__mobile {\n    display: block !important;\n  }\n\n  /* Tighten evidence card spacing on mobile — less padding, smaller gaps */\n  .sg-evidence-card {\n    margin-bottom: var(--space-2);\n  }\n  .sg-evidence-card__header {\n    padding: var(--space-2) var(--space-3);\n  }\n  .sg-evidence-card__body {\n    padding: var(--space-2) var(--space-3);\n  }\n  .sg-evidence-card__row-pair {\n    padding: var(--space-1) 0;\n    gap: 2px 10px;\n  }\n  .sg-evidence-card__title {\n    font-size: var(--text-sm);\n  }\n  .sg-evidence-card__label {\n    font-size: 0.625rem;\n  }\n  .sg-evidence-card__value {\n    font-size: 0.8125rem;\n  }\n}\n\n/* Narrow mobile (<420px): collapse two-column grid to single column.\n   Each cell in the pair stacks vertically. */\n@media (max-width: 420px) {\n  .sg-evidence-card__row-pair {\n    grid-template-columns: 1fr;\n    gap: 4px 0;\n  }\n  .sg-evidence-card__label {\n    font-size: 0.625rem;\n  }\n  .sg-evidence-card__value {\n    font-size: 0.8125rem;\n  }\n}\n\n/* --- Evidence Library Modal — split-pane (backported from audit-viewer) --- */\n\n/* Library shell: wider + taller than the small per-claim modal, and uses\n   flex-column so the body can host a flex-row split-pane. */\n.sg-modal--library {\n  max-width: 1100px;\n  width: 95vw;\n  height: 85vh;\n  display: flex;\n  flex-direction: column;\n}\n\n\n\n/* Library body is the split-pane container (desktop). Padding is zero so the\n   nav's border-right reaches the body edges; padding lives on each pane. */\n.sg-modal--library .sg-modal__body {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  min-height: 0;\n  padding: 0;\n  overflow: hidden;\n}\n.sg-library-body {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  min-height: 0;\n}\n\n/* Left nav — fixed width, its own scroll. Categories auto-expand when they\n   contain the selected entry so the user never loses orientation. */\n.sg-library-nav {\n  width: 300px;\n  flex-shrink: 0;\n  border-right: 1px solid var(--ims-border-light);\n  overflow-y: auto;\n  padding: var(--space-3);\n  background: var(--ims-bg-secondary);\n}\n\n/* Right content pane — fills remaining width, its own scroll. */\n.sg-library-content {\n  flex: 1;\n  min-width: 0;\n  overflow-y: auto;\n  padding: var(--space-4) var(--space-5);\n}\n\n/* Empty-state placeholder (right pane before any selection). */\n.sg-library-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  text-align: center;\n  color: var(--ims-text-secondary);\n  padding: var(--space-6);\n}\n.sg-library-placeholder__title {\n  font-size: var(--text-base);\n  font-weight: 500;\n  color: var(--ims-text-primary);\n  margin-bottom: var(--space-2);\n}\n.sg-library-placeholder__hint {\n  font-size: var(--text-sm);\n  color: var(--ims-text-secondary);\n  max-width: 320px;\n  line-height: 1.5;\n}\n\n/* Mobile drill-down back button — hidden on desktop. Shown on <768px OR\n   when .sg-modal--library-mobile-content is on (selection picked). */\n.sg-modal__back-btn {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  padding: var(--space-2) var(--space-3);\n  background: var(--ims-primary);\n  border: 1px solid var(--ims-primary);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  color: #ffffff;\n  font-size: var(--text-sm);\n  font-weight: 600;\n  margin-right: var(--space-3);\n  min-height: 40px;\n  font-family: inherit;\n}\n.sg-modal__back-btn:hover { opacity: 0.9; }\n.sg-modal__back-btn:active { opacity: 0.8; }\n.sg-modal__back-btn-label { line-height: 1; }\n\n/* --- Category accordion (top-level in left nav) --- */\n.sg-library-category {\n  margin-bottom: var(--space-2);\n  /* Override the legacy single-column style (border/radius/overflow-hidden\n     were appropriate for the full-width accordion; in split-pane they clip\n     the header's focus ring and fight the nav background). */\n  border: none;\n  border-radius: 0;\n  overflow: visible;\n}\n.sg-library-category__header {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--space-3);\n  background: var(--ims-bg-primary);\n  border: 1px solid var(--ims-border-light);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  text-align: left;\n  font-size: var(--text-base);\n  color: var(--ims-text-primary);\n  font-family: inherit;\n  transition: background 0.15s ease;\n}\n.sg-library-category__header:hover { background: var(--ims-bg-tertiary); }\n.sg-library-category__header[aria-expanded=\"true\"] {\n  background: var(--ims-bg-tertiary);\n  border-color: var(--ims-primary);\n}\n.sg-library-category__name {\n  font-weight: 600;\n  color: var(--ims-text-primary);\n}\n.sg-library-category__body {\n  padding: var(--space-2) 0 var(--space-2) var(--space-2);\n}\n.sg-library-category__tables {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  padding: 0;\n}\n\n/* Leaf table button — default / selected / disabled states. */\n.sg-library-table-btn {\n  width: 100%;\n  padding: var(--space-2) var(--space-3);\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  text-align: left;\n  font-size: var(--text-sm);\n  color: var(--ims-text-primary);\n  font-family: inherit;\n  transition: all 0.15s ease;\n  line-height: 1.4;\n}\n.sg-library-table-btn:hover:not(:disabled) {\n  background: var(--ims-bg-primary);\n  border-color: var(--ims-primary);\n}\n.sg-library-table-btn--disabled,\n.sg-library-table-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  font-style: italic;\n}\n.sg-library-table-btn--disabled:hover,\n.sg-library-table-btn:disabled:hover {\n  background: transparent;\n  border-color: transparent;\n}\n.sg-library-table-btn--selected {\n  background: var(--ims-primary);\n  color: #ffffff;\n  border-color: var(--ims-primary);\n  font-weight: 600;\n}\n.sg-library-table-btn--selected:hover:not(:disabled) {\n  background: var(--ims-primary);\n  color: #ffffff;\n  border-color: var(--ims-primary);\n}\n\n/* Mobile drill-down (<768px) — single pane at a time with a Back button. */\n@media (max-width: 768px) {\n  .sg-modal--library {\n    width: 100vw;\n    height: 100vh;\n    max-width: 100vw;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n  .sg-library-body {\n    flex-direction: column;\n    position: relative;\n  }\n  .sg-library-nav {\n    width: 100%;\n    border-right: none;\n    border-bottom: 1px solid var(--ims-border-light);\n    flex: 1;\n    min-height: 0;\n  }\n  .sg-library-content { display: none; }\n\n  /* When a table is picked, swap panes: content fills, nav hides, Back shows. */\n  .sg-modal--library-mobile-content .sg-library-nav { display: none; }\n  .sg-modal--library-mobile-content .sg-library-content {\n    display: block;\n    flex: 1;\n    min-height: 0;\n  }\n  .sg-modal--library-mobile-content .sg-modal__back-btn { display: inline-flex; }\n  .sg-modal--library-mobile-content .sg-modal__close { display: none; }\n\n  .sg-modal--library .sg-modal__header {\n    flex-wrap: wrap;\n    gap: var(--space-2);\n  }\n  .sg-modal--library .sg-modal__header-actions { flex-wrap: wrap; }\n\n  .sg-library-table-btn {\n    padding: var(--space-3);\n    font-size: var(--text-base);\n  }\n\n  /* Full-page mode mobile styles (mirrors modal mobile behavior) */\n  .sg-library-fullpage {\n    min-height: auto;\n    max-width: 100vw;\n    max-height: none;\n    border-radius: 0;\n  }\n\n  .sg-library-fullpage .sg-modal__body {\n    flex-direction: column;\n  }\n\n  .sg-library-fullpage .sg-library-nav {\n    width: 100%;\n    border-right: none;\n    border-bottom: 1px solid var(--ims-border-light);\n    flex: 1;\n    min-height: 0;\n  }\n\n  .sg-library-fullpage .sg-library-content {\n    display: none;\n  }\n\n  /* When a table is picked in full-page mobile, swap panes */\n  .sg-library-fullpage--content-view .sg-library-nav {\n    display: none;\n  }\n\n  .sg-library-fullpage--content-view .sg-library-content {\n    display: block;\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n  }\n\n  /* Push content above the persistent bottom tab bar */\n  .sg-library-fullpage .sg-modal__body {\n    flex-direction: column;\n    padding-bottom: calc(5.25rem + env(safe-area-inset-bottom));\n  }\n\n  /* Back button: only show in content-view (when a table is selected) */\n  .sg-library-fullpage .sg-modal__back-btn {\n    display: none;\n  }\n  .sg-library-fullpage--content-view .sg-modal__back-btn {\n    display: inline-flex;\n  }\n\n  /* Two-row header: title row centered, controls row (back + toggle) below.\n     Prevents cramming and horizontal overflow on narrow screens. */\n  .sg-library-fullpage .sg-modal__header {\n    display: grid;\n    grid-template-areas:\n      \"title title\"\n      \"back  actions\";\n    grid-template-columns: auto 1fr;\n    align-items: center;\n    gap: 0.35rem 0.5rem;\n    padding: 0.75rem 1rem;\n  }\n  /* Title wrapper — the unclassed div between back button and actions */\n  .sg-library-fullpage .sg-modal__header > :not(.sg-modal__back-btn):not(.sg-modal__header-actions) {\n    grid-area: title;\n    justify-self: center;\n    text-align: center;\n  }\n  .sg-library-fullpage .sg-modal__title {\n    text-align: center;\n    font-size: 1rem;\n    line-height: 1.2;\n  }\n  .sg-library-fullpage .sg-modal__back-btn {\n    grid-area: back;\n  }\n  .sg-library-fullpage .sg-modal__header-actions {\n    grid-area: actions;\n    justify-self: end;\n    flex-wrap: wrap;\n  }\n\n  /* Smaller, subtler back button */\n  .sg-modal__back-btn {\n    padding: 0.35rem 0.55rem;\n    font-size: 0.78rem;\n    border-radius: var(--radius-full);\n    background: var(--ims-bg-primary);\n    color: var(--ims-primary);\n    border: 1px solid var(--ims-border-medium, #d1d5db);\n    gap: 0.25rem;\n    min-height: auto;\n  }\n}\n\n/* Nav Pill Icon Style */\n.sg-nav-pill--icon {\n  min-width: 40px;\n  text-align: center;\n}\n\n.sg-loading {\n  display: flex;\n  min-height: 60vh;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-4);\n}\n\n/* Compact variant — reduces vertical space for quick loads */\n.sg-loading--compact {\n  min-height: 40vh;\n}\n\n.sg-loading__spinner {\n  width: 44px;\n  height: 44px;\n  border: 3px solid var(--ims-border-light);\n  border-top-color: var(--ims-primary);\n  border-radius: 50%;\n  animation: sg-spin 1s linear infinite;\n}\n\n.sg-loading__text { color: var(--ims-text-secondary); font-size: var(--text-base); }\n\n@keyframes sg-spin { to { transform: rotate(360deg); } }\n\n@media (max-width: 860px) {\n  .sg-container { padding: var(--space-4); }\n  .sg-sections-row { grid-template-columns: 1fr; }\n  .sg-block-header { flex-direction: column; align-items: flex-start; }\n  .sg-tier-performance__row { flex-direction: column; }\n  .sg-modal-backdrop { padding: var(--space-3); }\n  .sg-modal { max-height: 92vh; }\n}\n\n@media print {\n  .sg-toolbar,\n  .sg-modal-backdrop,\n  .sg-rating-card,\n  .sg-lens-toggle,\n  .sg-inline-toggle,\n  .sg-beta-banner {\n    display: none !important;\n  }\n\n  /* Keep the BETA pill visible in print so the document carries its status,\n     but strip interactive affordances. */\n  .sg-beta-badge {\n    cursor: default;\n  }\n\n  .sg-card,\n  .sg-top-card {\n    box-shadow: none;\n    border: 1px solid var(--ims-border-light);\n    break-inside: avoid;\n  }\n\n  .sg-container {\n    max-width: none;\n    padding: 0;\n  }\n}\n\n/* ============================================\n   IMS FOOTER - Design Team Requirements\n   ============================================ */\n\n.sg-footer {\n  background-color: var(--ims-bg-secondary);\n  border-top: 1px solid var(--ims-border-light);\n  margin-top: var(--space-12);\n  padding: var(--space-8) 0;\n}\n\n.sg-footer__inner {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 var(--space-6);\n}\n\n/* AI Disclaimer — shown only in Report tab */\n.sg-ai-disclaimer {\n  background-color: var(--ims-bg-tertiary);\n  border-left: 4px solid var(--ims-accent);\n  padding: var(--space-4);\n  margin-top: var(--space-8);\n  margin-bottom: var(--space-4);\n  border-radius: 0 var(--radius) var(--radius) 0;\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.sg-ai-disclaimer p {\n  font-size: var(--text-sm);\n  color: var(--ims-text-secondary);\n  line-height: var(--leading-normal);\n  margin: 0;\n}\n\n.sg-ai-disclaimer strong {\n  color: var(--ims-text-primary);\n  font-weight: 600;\n}\n\n/* Navigation Links */\n.sg-footer__links {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: var(--space-3);\n  margin-bottom: var(--space-6);\n  padding: var(--space-4) 0;\n  border-top: 1px solid var(--ims-border-light);\n}\n\n.sg-footer__links a {\n  font-size: var(--text-sm);\n  color: var(--ims-text-secondary);\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.sg-footer__links a:hover {\n  color: var(--ims-primary);\n  text-decoration: underline;\n}\n\n.sg-footer__divider {\n  color: var(--ims-text-muted);\n  font-size: var(--text-sm);\n}\n\n/* Social Icons */\n.sg-footer__social {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-4);\n  margin-bottom: var(--space-6);\n  padding-top: var(--space-6);\n  border-top: 1px solid var(--ims-border-light);\n}\n\n.sg-footer__social span {\n  font-size: var(--text-sm);\n  color: var(--ims-text-muted);\n}\n\n/* Mobile Responsiveness for Tab Navigation */\n@media (max-width: 768px) {\n  .sg-main-tab-nav {\n    display: none;\n  }\n\n  .sg-tab-content {\n    padding: 1rem;\n    padding-bottom: calc(5.25rem + env(safe-area-inset-bottom)); /* clear the persistent bottom tab bar */\n  }\n\n  /* Hide desktop tab wrapper completely on mobile — no border, no padding */\n  .sg-main-tab-nav-wrapper {\n    display: none !important;\n    height: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    border: 0 !important;\n  }\n\n  /* Mobile full-screen tool overlays */\n  .sg-mobile-tool-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: var(--ims-bg-primary);\n    z-index: 1000;\n    overflow-y: auto;\n  }\n\n  .sg-mobile-tool-overlay .sg-modal__header {\n    position: sticky;\n    top: 0;\n    background: var(--ims-bg-primary);\n    z-index: 10;\n    border-bottom: 1px solid var(--ims-border-light);\n  }\n}\n\n.sg-footer__social a {\n  color: var(--ims-text-secondary);\n  transition: color 0.2s ease, transform 0.2s ease;\n}\n\n.sg-footer__social a:hover {\n  color: var(--ims-primary);\n  transform: translateY(-2px);\n}\n\n.sg-footer__social svg {\n  width: 24px;\n  height: 24px;\n}\n\n/* Copyright */\n.sg-footer__copyright {\n  text-align: center;\n  padding-top: var(--space-6);\n  border-top: 1px solid var(--ims-border-light);\n}\n\n.sg-footer__copyright p {\n  font-size: var(--text-xs);\n  color: var(--ims-text-muted);\n  margin: 0;\n}\n\n/* Footer Responsive */\n@media (max-width: 640px) {\n  .sg-footer__links {\n    gap: var(--space-2);\n  }\n  \n  .sg-footer__divider {\n    display: none;\n  }\n  \n  .sg-footer__social {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n}\n\n/* ── Category Modal (early return — full-screen overlay) ── */\n.sg-category-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 50;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  background-color: #0F1F33;\n  min-height: 100vh;\n}\n\n.sg-category-modal {\n  background: #fff;\n  width: 100%;\n  max-width: 400px;\n  border-radius: 1rem;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.3);\n  overflow: hidden;\n}\n\n.sg-category-modal__header {\n  padding: 1.25rem 1.5rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.sg-category-modal__header h2 {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin: 0 0 0.25rem;\n}\n\n.sg-category-modal__header p {\n  font-size: 0.8125rem;\n  color: #64748b;\n  line-height: 1.5;\n  margin: 0.25rem 0 0;\n}\n\n.sg-category-modal__dots {\n  display: flex;\n  gap: 0.375rem;\n  margin-bottom: 0.75rem;\n}\n\n.sg-category-modal__dot {\n  width: 0.375rem;\n  height: 0.375rem;\n  border-radius: 50%;\n  background: #e2e8f0;\n}\n\n.sg-category-modal__dot--active {\n  background: #1E3A5F;\n}\n\n.sg-category-modal__body {\n  padding: 1.25rem 1.5rem;\n}\n\n.sg-category-modal__select {\n  width: 100%;\n  padding: 0.625rem 0.75rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.75rem;\n  background: #fff;\n  font-size: 0.875rem;\n  color: #1e293b;\n  outline: none;\n  appearance: none;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.sg-category-modal__select:focus {\n  border-color: #1E3A5F;\n  box-shadow: 0 0 0 2px rgba(30, 58, 95, 0.1);\n}\n\n.sg-category-modal__warning {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  margin-top: 0.875rem;\n  padding: 0.625rem 0.75rem;\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n  border-radius: 0.5rem;\n}\n\n.sg-category-modal__warning svg {\n  color: #d97706;\n  flex-shrink: 0;\n  margin-top: 0.125rem;\n}\n\n.sg-category-modal__warning p {\n  font-size: 0.75rem;\n  color: #92400e;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.sg-category-modal__footer {\n  display: flex;\n  gap: 0.5rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #f1f5f9;\n}\n\n\n.sg-category-modal__btn {\n  flex: 1;\n  padding: 0.625rem 1rem;\n  border-radius: 0.75rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.375rem;\n  transition: background-color 0.2s, opacity 0.2s;\n  border: none;\n}\n\n.sg-category-modal__btn--primary {\n  background: #1E3A5F;\n  color: #fff;\n}\n\n.sg-category-modal__btn--primary:hover:not(:disabled) {\n  background: #2D5A8E;\n}\n\n.sg-category-modal__btn--primary:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.sg-category-modal__btn--secondary {\n  background: transparent;\n  border: 1px solid #e2e8f0;\n  color: #64748b;\n}\n\n.sg-category-modal__btn--secondary:hover:not(:disabled) {\n  background: #f8fafc;\n  color: #334155;\n}\n\n.sg-category-modal__selected {\n  text-align: center;\n  margin-bottom: 1.25rem;\n}\n\n.sg-category-modal__selected-label {\n  display: block;\n  font-size: 0.6875rem;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-weight: 600;\n  margin-bottom: 0.625rem;\n}\n\n.sg-category-modal__selected-value {\n  display: inline-flex;\n  padding: 0.625rem 1.25rem;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 0.75rem;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: #1E3A5F;\n}\n\n.sg-category-modal__danger {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 0.75rem;\n  padding: 1rem;\n}\n\n.sg-category-modal__danger p {\n  margin: 0;\n  font-size: 0.875rem;\n  color: #991b1b;\n  line-height: 1.5;\n}\n\n.sg-category-modal__danger p:first-child {\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n\n.sg-category-modal__danger p:last-child {\n  font-size: 0.75rem;\n  color: rgba(153, 27, 27, 0.85);\n}\n\n/* -------------------------------------------------------------------------\n   Generation stepper (wait screen) — vertical 6-step ladder\n   The checked ladder IS the progress; no percent numbers, no raw enums.\n   ------------------------------------------------------------------------- */\n.sg-stepper-wrap {\n  min-height: 100vh;\n  min-height: 100dvh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 16px;\n  box-sizing: border-box;\n}\n\n.sg-stepper {\n  width: 100%;\n  max-width: 560px;\n  padding: 32px 36px;\n  background: var(--ims-bg-primary);\n  border: 1px solid var(--ims-border-light);\n  border-radius: 12px;\n  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);\n}\n\n.sg-stepper__title {\n  margin: 0 0 24px;\n  text-align: center;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--ims-text-primary);\n}\n\n.sg-stepper__list { list-style: none; margin: 0; padding: 0; }\n\n.sg-step { position: relative; display: flex; gap: 14px; padding-bottom: 22px; }\n.sg-step:last-child { padding-bottom: 0; }\n\n/* connector line between step icons */\n.sg-step:not(:last-child)::before {\n  content: '';\n  position: absolute;\n  left: 11px; top: 26px; bottom: 2px;\n  width: 2px;\n  background: var(--ims-border-light);\n}\n.sg-step--done:not(:last-child)::before { background: var(--ims-primary); }\n\n.sg-step__icon {\n  flex: 0 0 24px;\n  width: 24px; height: 24px;\n  border-radius: 50%;\n  display: flex; align-items: center; justify-content: center;\n  font-size: 13px; font-weight: 700;\n  background: var(--ims-border-light);\n  color: var(--ims-text-secondary);\n  z-index: 1;\n}\n.sg-step--done .sg-step__icon { background: var(--ims-primary); color: #fff; }\n.sg-step--active .sg-step__icon { background: var(--ims-bg-primary); border: 2px solid var(--ims-primary); }\n.sg-step--pending .sg-step__icon { background: var(--ims-bg-primary); border: 2px solid var(--ims-text-light); }\n\n.sg-step__pulse {\n  width: 10px; height: 10px;\n  border-radius: 50%;\n  background: var(--ims-primary);\n  animation: sg-step-pulse 1.2s ease-in-out infinite;\n}\n@keyframes sg-step-pulse {\n  0%, 100% { transform: scale(0.75); opacity: 0.6; }\n  50% { transform: scale(1); opacity: 1; }\n}\n\n.sg-step__label { font-size: 14.5px; font-weight: 600; line-height: 24px; color: var(--ims-text-primary); }\n.sg-step--pending .sg-step__label { color: var(--ims-text-muted); }\n.sg-step__label-short { display: none; }\n\n.sg-step__hint { margin: 4px 0 0; font-size: 13px; color: var(--ims-text-secondary); }\n\n.sg-stepper__footer {\n  margin: 24px 0 0;\n  padding-top: 16px;\n  border-top: 1px solid var(--ims-bg-secondary);\n  text-align: center;\n  font-size: 13px;\n  color: var(--ims-text-secondary);\n}\n\n@media (max-width: 640px) {\n  .sg-stepper-wrap { padding: 16px 12px; }\n  .sg-stepper { padding: 24px 20px; }\n  .sg-step__label-full { display: none; }\n  .sg-step__label-short { display: inline; }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
